import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
};

export type Query = {
   __typename?: 'Query';
  client?: Maybe<Client>;
  clients?: Maybe<Array<Maybe<Client>>>;
  clientsConnection?: Maybe<ClientConnection>;
  document?: Maybe<Document>;
  documents?: Maybe<Array<Maybe<Document>>>;
  documentsConnection?: Maybe<DocumentConnection>;
  featureTemplate?: Maybe<FeatureTemplate>;
  featureTemplates?: Maybe<Array<Maybe<FeatureTemplate>>>;
  featureTemplatesConnection?: Maybe<FeatureTemplateConnection>;
  project?: Maybe<Project>;
  projects?: Maybe<Array<Maybe<Project>>>;
  projectsConnection?: Maybe<ProjectConnection>;
  quote?: Maybe<Quote>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
  quotesConnection?: Maybe<QuoteConnection>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
  reportsConnection?: Maybe<ReportConnection>;
  setting?: Maybe<Settings>;
  subscription?: Maybe<Subscription>;
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  subscriptionsConnection?: Maybe<SubscriptionConnection>;
  template?: Maybe<Template>;
  templates?: Maybe<Array<Maybe<Template>>>;
  templatesConnection?: Maybe<TemplateConnection>;
  term?: Maybe<Terms>;
  terms?: Maybe<Array<Maybe<Terms>>>;
  termsConnection?: Maybe<TermsConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  totalClients?: Maybe<Scalars['Int']>;
  getDashboard?: Maybe<DashboardOutput>;
  totalProjects?: Maybe<Scalars['Int']>;
  totalQuotes?: Maybe<Scalars['Int']>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryClientArgs = {
  id: Scalars['ID'];
};


export type QueryClientsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryClientsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDocumentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFeatureTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryFeatureTemplatesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFeatureTemplatesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryProjectsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProjectsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryQuotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryQuotesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReportsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};


export type QuerySubscriptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubscriptionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryTemplatesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTemplatesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTermArgs = {
  id: Scalars['ID'];
};


export type QueryTermsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTermsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Client = {
   __typename?: 'Client';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  companyName?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  colour?: Maybe<Scalars['String']>;
  avatar?: Maybe<UploadFile>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  projects?: Maybe<Array<Maybe<Project>>>;
  members?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  documents?: Maybe<Array<Maybe<Document>>>;
};


export type ClientProjectsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ClientMembersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ClientSubscriptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ClientDocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UploadFile = {
   __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type AdminUser = {
   __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type Morph = DashboardOutput | DocTemplate | EmailStatus | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | Client | ClientConnection | ClientAggregator | ClientAggregatorSum | ClientAggregatorAvg | ClientAggregatorMin | ClientAggregatorMax | ClientGroupBy | ClientConnectionId | ClientConnectionCreated_At | ClientConnectionUpdated_At | ClientConnectionCompanyName | ClientConnectionIndustry | ClientConnectionCountry | ClientConnectionSize | ClientConnectionWebsite | ClientConnectionLogo | ClientConnectionSector | ClientConnectionColour | ClientConnectionAvatar | ClientConnectionCreated_By | ClientConnectionUpdated_By | CreateClientPayload | UpdateClientPayload | DeleteClientPayload | Document | DocumentConnection | DocumentAggregator | DocumentGroupBy | DocumentConnectionId | DocumentConnectionCreated_At | DocumentConnectionUpdated_At | DocumentConnectionName | DocumentConnectionLink | DocumentConnectionFile | DocumentConnectionProject | DocumentConnectionClient | DocumentConnectionCreated_By | DocumentConnectionUpdated_By | CreateDocumentPayload | UpdateDocumentPayload | DeleteDocumentPayload | FeatureTemplate | FeatureTemplateConnection | FeatureTemplateAggregator | FeatureTemplateAggregatorSum | FeatureTemplateAggregatorAvg | FeatureTemplateAggregatorMin | FeatureTemplateAggregatorMax | FeatureTemplateGroupBy | FeatureTemplateConnectionId | FeatureTemplateConnectionCreated_At | FeatureTemplateConnectionUpdated_At | FeatureTemplateConnectionName | FeatureTemplateConnectionHours | FeatureTemplateConnectionThumbnail | FeatureTemplateConnectionIntegration | FeatureTemplateConnectionDescription | FeatureTemplateConnectionDesktop | FeatureTemplateConnectionMobile | FeatureTemplateConnectionCustom | FeatureTemplateConnectionCreated_By | FeatureTemplateConnectionUpdated_By | CreateFeatureTemplatePayload | UpdateFeatureTemplatePayload | DeleteFeatureTemplatePayload | Project | ProjectConnection | ProjectAggregator | ProjectAggregatorSum | ProjectAggregatorAvg | ProjectAggregatorMin | ProjectAggregatorMax | ProjectGroupBy | ProjectConnectionId | ProjectConnectionCreated_At | ProjectConnectionUpdated_At | ProjectConnectionName | ProjectConnectionDescription | ProjectConnectionLogo | ProjectConnectionClient | ProjectConnectionRep | ProjectConnectionProblem | ProjectConnectionSolution | ProjectConnectionMarket | ProjectConnectionIndustry | ProjectConnectionUsers | ProjectConnectionNeed | ProjectConnectionGeography | ProjectConnectionFrequency | ProjectConnectionPartner | ProjectConnectionActual_Duration | ProjectConnectionStatus | ProjectConnectionCreated_By | ProjectConnectionUpdated_By | CreateProjectPayload | UpdateProjectPayload | DeleteProjectPayload | Quote | QuoteConnection | QuoteAggregator | QuoteAggregatorSum | QuoteAggregatorAvg | QuoteAggregatorMin | QuoteAggregatorMax | QuoteGroupBy | QuoteConnectionId | QuoteConnectionCreated_At | QuoteConnectionUpdated_At | QuoteConnectionProject | QuoteConnectionName | QuoteConnectionStatus | QuoteConnectionNodes | QuoteConnectionHours | QuoteConnectionDesign | QuoteConnectionSubmitted_At | QuoteConnectionApproved_At | QuoteConnectionChanges | QuoteConnectionCreated_By | QuoteConnectionUpdated_By | CreateQuotePayload | UpdateQuotePayload | DeleteQuotePayload | Report | ReportConnection | ReportAggregator | ReportGroupBy | ReportConnectionId | ReportConnectionCreated_At | ReportConnectionUpdated_At | ReportConnectionDate | ReportConnectionInvoice | ReportConnectionNps | ReportConnectionProgress | ReportConnectionSubscription | ReportConnectionCreated_By | ReportConnectionUpdated_By | CreateReportPayload | UpdateReportPayload | DeleteReportPayload | Settings | UpdateSettingPayload | DeleteSettingPayload | Subscription | SubscriptionConnection | SubscriptionAggregator | SubscriptionGroupBy | SubscriptionConnectionId | SubscriptionConnectionCreated_At | SubscriptionConnectionUpdated_At | SubscriptionConnectionName | SubscriptionConnectionConfiguration | SubscriptionConnectionClient | SubscriptionConnectionStart | SubscriptionConnectionEnd | SubscriptionConnectionHours | SubscriptionConnectionStatus | SubscriptionConnectionCreated_By | SubscriptionConnectionUpdated_By | CreateSubscriptionPayload | UpdateSubscriptionPayload | DeleteSubscriptionPayload | Template | TemplateConnection | TemplateAggregator | TemplateAggregatorSum | TemplateAggregatorAvg | TemplateAggregatorMin | TemplateAggregatorMax | TemplateGroupBy | TemplateConnectionId | TemplateConnectionCreated_At | TemplateConnectionUpdated_At | TemplateConnectionName | TemplateConnectionFlow | TemplateConnectionHours | TemplateConnectionCreated_By | TemplateConnectionUpdated_By | CreateTemplatePayload | UpdateTemplatePayload | DeleteTemplatePayload | Terms | TermsConnection | TermsAggregator | TermsGroupBy | TermsConnectionId | TermsConnectionCreated_At | TermsConnectionUpdated_At | TermsConnectionName | TermsConnectionDocument | TermsConnectionCreated_By | TermsConnectionUpdated_By | CreateTermPayload | UpdateTermPayload | DeleteTermPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionCreated_By | UploadFileConnectionUpdated_By | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | UsersPermissionsRoleConnectionCreated_By | UsersPermissionsRoleConnectionUpdated_By | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionPhoneNumber | UsersPermissionsUserConnectionProfilePicture | UsersPermissionsUserConnectionFullName | UsersPermissionsUserConnectionOauth | UsersPermissionsUserConnectionMemberId | UsersPermissionsUserConnectionClient | UsersPermissionsUserConnectionCreated_By | UsersPermissionsUserConnectionUpdated_By | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentContactContact | ComponentQuotationLineItem;

export type DashboardOutput = {
   __typename?: 'DashboardOutput';
  reviewQuotes?: Maybe<Array<Maybe<Quote>>>;
  recentApprovedQuotes?: Maybe<Array<Maybe<Quote>>>;
  createdQuotes?: Maybe<Array<Maybe<Quote>>>;
  approvedQuotes?: Maybe<Array<Maybe<Quote>>>;
  submittedQuotes?: Maybe<Array<Maybe<Quote>>>;
};

export type Quote = {
   __typename?: 'Quote';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  project?: Maybe<Project>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Quote_Status>;
  nodes?: Maybe<Scalars['JSON']>;
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
  submitted_at?: Maybe<Scalars['DateTime']>;
  approved_at?: Maybe<Scalars['DateTime']>;
  changes?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type Project = {
   __typename?: 'Project';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  client?: Maybe<Client>;
  rep?: Maybe<UsersPermissionsUser>;
  problem?: Maybe<Scalars['String']>;
  solution?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['String']>;
  need?: Maybe<Scalars['String']>;
  geography?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['Boolean']>;
  actual_duration?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Project_Status>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
  documents?: Maybe<Array<Maybe<Document>>>;
  stakeholders?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type ProjectQuotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProjectDocumentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProjectStakeholdersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUser = {
   __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<UploadFile>;
  fullName?: Maybe<Scalars['String']>;
  oauth?: Maybe<Scalars['JSON']>;
  memberID?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  projects?: Maybe<Array<Maybe<Project>>>;
  clientprojects?: Maybe<Array<Maybe<Project>>>;
};


export type UsersPermissionsUserProjectsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserClientprojectsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRole = {
   __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsPermission = {
   __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export enum Enum_Project_Status {
  InProgress = 'IN_PROGRESS',
  Delivered = 'DELIVERED'
}

export type Document = {
   __typename?: 'Document';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  file?: Maybe<UploadFile>;
  project?: Maybe<Project>;
  client?: Maybe<Client>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export enum Enum_Quote_Status {
  New = 'NEW',
  Review = 'REVIEW',
  Approved = 'APPROVED',
  Accepted = 'ACCEPTED'
}

export type DocTemplate = {
   __typename?: 'DocTemplate';
  url?: Maybe<Scalars['String']>;
};

export type EmailStatus = {
   __typename?: 'EmailStatus';
  sent?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsMe = {
   __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
   __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
   __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UserPermissionsPasswordPayload = {
   __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type ClientConnection = {
   __typename?: 'ClientConnection';
  values?: Maybe<Array<Maybe<Client>>>;
  groupBy?: Maybe<ClientGroupBy>;
  aggregate?: Maybe<ClientAggregator>;
};

export type ClientGroupBy = {
   __typename?: 'ClientGroupBy';
  id?: Maybe<Array<Maybe<ClientConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ClientConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ClientConnectionUpdated_At>>>;
  companyName?: Maybe<Array<Maybe<ClientConnectionCompanyName>>>;
  industry?: Maybe<Array<Maybe<ClientConnectionIndustry>>>;
  country?: Maybe<Array<Maybe<ClientConnectionCountry>>>;
  size?: Maybe<Array<Maybe<ClientConnectionSize>>>;
  website?: Maybe<Array<Maybe<ClientConnectionWebsite>>>;
  logo?: Maybe<Array<Maybe<ClientConnectionLogo>>>;
  sector?: Maybe<Array<Maybe<ClientConnectionSector>>>;
  colour?: Maybe<Array<Maybe<ClientConnectionColour>>>;
  avatar?: Maybe<Array<Maybe<ClientConnectionAvatar>>>;
  created_by?: Maybe<Array<Maybe<ClientConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ClientConnectionUpdated_By>>>;
};

export type ClientConnectionId = {
   __typename?: 'ClientConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionCreated_At = {
   __typename?: 'ClientConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionUpdated_At = {
   __typename?: 'ClientConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionCompanyName = {
   __typename?: 'ClientConnectionCompanyName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionIndustry = {
   __typename?: 'ClientConnectionIndustry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionCountry = {
   __typename?: 'ClientConnectionCountry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionSize = {
   __typename?: 'ClientConnectionSize';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionWebsite = {
   __typename?: 'ClientConnectionWebsite';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionLogo = {
   __typename?: 'ClientConnectionLogo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionSector = {
   __typename?: 'ClientConnectionSector';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionColour = {
   __typename?: 'ClientConnectionColour';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionAvatar = {
   __typename?: 'ClientConnectionAvatar';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionCreated_By = {
   __typename?: 'ClientConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientConnectionUpdated_By = {
   __typename?: 'ClientConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ClientConnection>;
};

export type ClientAggregator = {
   __typename?: 'ClientAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ClientAggregatorSum>;
  avg?: Maybe<ClientAggregatorAvg>;
  min?: Maybe<ClientAggregatorMin>;
  max?: Maybe<ClientAggregatorMax>;
};

export type ClientAggregatorSum = {
   __typename?: 'ClientAggregatorSum';
  size?: Maybe<Scalars['Float']>;
};

export type ClientAggregatorAvg = {
   __typename?: 'ClientAggregatorAvg';
  size?: Maybe<Scalars['Float']>;
};

export type ClientAggregatorMin = {
   __typename?: 'ClientAggregatorMin';
  size?: Maybe<Scalars['Float']>;
};

export type ClientAggregatorMax = {
   __typename?: 'ClientAggregatorMax';
  size?: Maybe<Scalars['Float']>;
};

export type CreateClientPayload = {
   __typename?: 'createClientPayload';
  client?: Maybe<Client>;
};

export type UpdateClientPayload = {
   __typename?: 'updateClientPayload';
  client?: Maybe<Client>;
};

export type DeleteClientPayload = {
   __typename?: 'deleteClientPayload';
  client?: Maybe<Client>;
};

export type DocumentConnection = {
   __typename?: 'DocumentConnection';
  values?: Maybe<Array<Maybe<Document>>>;
  groupBy?: Maybe<DocumentGroupBy>;
  aggregate?: Maybe<DocumentAggregator>;
};

export type DocumentGroupBy = {
   __typename?: 'DocumentGroupBy';
  id?: Maybe<Array<Maybe<DocumentConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DocumentConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DocumentConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<DocumentConnectionName>>>;
  link?: Maybe<Array<Maybe<DocumentConnectionLink>>>;
  file?: Maybe<Array<Maybe<DocumentConnectionFile>>>;
  project?: Maybe<Array<Maybe<DocumentConnectionProject>>>;
  client?: Maybe<Array<Maybe<DocumentConnectionClient>>>;
  created_by?: Maybe<Array<Maybe<DocumentConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<DocumentConnectionUpdated_By>>>;
};

export type DocumentConnectionId = {
   __typename?: 'DocumentConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionCreated_At = {
   __typename?: 'DocumentConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionUpdated_At = {
   __typename?: 'DocumentConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionName = {
   __typename?: 'DocumentConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionLink = {
   __typename?: 'DocumentConnectionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionFile = {
   __typename?: 'DocumentConnectionFile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionProject = {
   __typename?: 'DocumentConnectionProject';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionClient = {
   __typename?: 'DocumentConnectionClient';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionCreated_By = {
   __typename?: 'DocumentConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentConnectionUpdated_By = {
   __typename?: 'DocumentConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DocumentConnection>;
};

export type DocumentAggregator = {
   __typename?: 'DocumentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateDocumentPayload = {
   __typename?: 'createDocumentPayload';
  document?: Maybe<Document>;
};

export type UpdateDocumentPayload = {
   __typename?: 'updateDocumentPayload';
  document?: Maybe<Document>;
};

export type DeleteDocumentPayload = {
   __typename?: 'deleteDocumentPayload';
  document?: Maybe<Document>;
};

export type FeatureTemplate = {
   __typename?: 'FeatureTemplate';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['Float']>;
  thumbnail?: Maybe<UploadFile>;
  integration?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  desktop?: Maybe<UploadFile>;
  mobile?: Maybe<UploadFile>;
  custom?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type FeatureTemplateConnection = {
   __typename?: 'FeatureTemplateConnection';
  values?: Maybe<Array<Maybe<FeatureTemplate>>>;
  groupBy?: Maybe<FeatureTemplateGroupBy>;
  aggregate?: Maybe<FeatureTemplateAggregator>;
};

export type FeatureTemplateGroupBy = {
   __typename?: 'FeatureTemplateGroupBy';
  id?: Maybe<Array<Maybe<FeatureTemplateConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FeatureTemplateConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FeatureTemplateConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<FeatureTemplateConnectionName>>>;
  hours?: Maybe<Array<Maybe<FeatureTemplateConnectionHours>>>;
  thumbnail?: Maybe<Array<Maybe<FeatureTemplateConnectionThumbnail>>>;
  integration?: Maybe<Array<Maybe<FeatureTemplateConnectionIntegration>>>;
  description?: Maybe<Array<Maybe<FeatureTemplateConnectionDescription>>>;
  desktop?: Maybe<Array<Maybe<FeatureTemplateConnectionDesktop>>>;
  mobile?: Maybe<Array<Maybe<FeatureTemplateConnectionMobile>>>;
  custom?: Maybe<Array<Maybe<FeatureTemplateConnectionCustom>>>;
  created_by?: Maybe<Array<Maybe<FeatureTemplateConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<FeatureTemplateConnectionUpdated_By>>>;
};

export type FeatureTemplateConnectionId = {
   __typename?: 'FeatureTemplateConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionCreated_At = {
   __typename?: 'FeatureTemplateConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionUpdated_At = {
   __typename?: 'FeatureTemplateConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionName = {
   __typename?: 'FeatureTemplateConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionHours = {
   __typename?: 'FeatureTemplateConnectionHours';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionThumbnail = {
   __typename?: 'FeatureTemplateConnectionThumbnail';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionIntegration = {
   __typename?: 'FeatureTemplateConnectionIntegration';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionDescription = {
   __typename?: 'FeatureTemplateConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionDesktop = {
   __typename?: 'FeatureTemplateConnectionDesktop';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionMobile = {
   __typename?: 'FeatureTemplateConnectionMobile';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionCustom = {
   __typename?: 'FeatureTemplateConnectionCustom';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionCreated_By = {
   __typename?: 'FeatureTemplateConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateConnectionUpdated_By = {
   __typename?: 'FeatureTemplateConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FeatureTemplateConnection>;
};

export type FeatureTemplateAggregator = {
   __typename?: 'FeatureTemplateAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<FeatureTemplateAggregatorSum>;
  avg?: Maybe<FeatureTemplateAggregatorAvg>;
  min?: Maybe<FeatureTemplateAggregatorMin>;
  max?: Maybe<FeatureTemplateAggregatorMax>;
};

export type FeatureTemplateAggregatorSum = {
   __typename?: 'FeatureTemplateAggregatorSum';
  hours?: Maybe<Scalars['Float']>;
};

export type FeatureTemplateAggregatorAvg = {
   __typename?: 'FeatureTemplateAggregatorAvg';
  hours?: Maybe<Scalars['Float']>;
};

export type FeatureTemplateAggregatorMin = {
   __typename?: 'FeatureTemplateAggregatorMin';
  hours?: Maybe<Scalars['Float']>;
};

export type FeatureTemplateAggregatorMax = {
   __typename?: 'FeatureTemplateAggregatorMax';
  hours?: Maybe<Scalars['Float']>;
};

export type CreateFeatureTemplatePayload = {
   __typename?: 'createFeatureTemplatePayload';
  featureTemplate?: Maybe<FeatureTemplate>;
};

export type UpdateFeatureTemplatePayload = {
   __typename?: 'updateFeatureTemplatePayload';
  featureTemplate?: Maybe<FeatureTemplate>;
};

export type DeleteFeatureTemplatePayload = {
   __typename?: 'deleteFeatureTemplatePayload';
  featureTemplate?: Maybe<FeatureTemplate>;
};

export type ProjectConnection = {
   __typename?: 'ProjectConnection';
  values?: Maybe<Array<Maybe<Project>>>;
  groupBy?: Maybe<ProjectGroupBy>;
  aggregate?: Maybe<ProjectAggregator>;
};

export type ProjectGroupBy = {
   __typename?: 'ProjectGroupBy';
  id?: Maybe<Array<Maybe<ProjectConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProjectConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProjectConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ProjectConnectionName>>>;
  description?: Maybe<Array<Maybe<ProjectConnectionDescription>>>;
  logo?: Maybe<Array<Maybe<ProjectConnectionLogo>>>;
  client?: Maybe<Array<Maybe<ProjectConnectionClient>>>;
  rep?: Maybe<Array<Maybe<ProjectConnectionRep>>>;
  problem?: Maybe<Array<Maybe<ProjectConnectionProblem>>>;
  solution?: Maybe<Array<Maybe<ProjectConnectionSolution>>>;
  market?: Maybe<Array<Maybe<ProjectConnectionMarket>>>;
  industry?: Maybe<Array<Maybe<ProjectConnectionIndustry>>>;
  users?: Maybe<Array<Maybe<ProjectConnectionUsers>>>;
  need?: Maybe<Array<Maybe<ProjectConnectionNeed>>>;
  geography?: Maybe<Array<Maybe<ProjectConnectionGeography>>>;
  frequency?: Maybe<Array<Maybe<ProjectConnectionFrequency>>>;
  partner?: Maybe<Array<Maybe<ProjectConnectionPartner>>>;
  actual_duration?: Maybe<Array<Maybe<ProjectConnectionActual_Duration>>>;
  status?: Maybe<Array<Maybe<ProjectConnectionStatus>>>;
  created_by?: Maybe<Array<Maybe<ProjectConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ProjectConnectionUpdated_By>>>;
};

export type ProjectConnectionId = {
   __typename?: 'ProjectConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionCreated_At = {
   __typename?: 'ProjectConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionUpdated_At = {
   __typename?: 'ProjectConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionName = {
   __typename?: 'ProjectConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionDescription = {
   __typename?: 'ProjectConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionLogo = {
   __typename?: 'ProjectConnectionLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionClient = {
   __typename?: 'ProjectConnectionClient';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionRep = {
   __typename?: 'ProjectConnectionRep';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionProblem = {
   __typename?: 'ProjectConnectionProblem';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionSolution = {
   __typename?: 'ProjectConnectionSolution';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionMarket = {
   __typename?: 'ProjectConnectionMarket';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionIndustry = {
   __typename?: 'ProjectConnectionIndustry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionUsers = {
   __typename?: 'ProjectConnectionUsers';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionNeed = {
   __typename?: 'ProjectConnectionNeed';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionGeography = {
   __typename?: 'ProjectConnectionGeography';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionFrequency = {
   __typename?: 'ProjectConnectionFrequency';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionPartner = {
   __typename?: 'ProjectConnectionPartner';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionActual_Duration = {
   __typename?: 'ProjectConnectionActual_duration';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionStatus = {
   __typename?: 'ProjectConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionCreated_By = {
   __typename?: 'ProjectConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectConnectionUpdated_By = {
   __typename?: 'ProjectConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProjectConnection>;
};

export type ProjectAggregator = {
   __typename?: 'ProjectAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ProjectAggregatorSum>;
  avg?: Maybe<ProjectAggregatorAvg>;
  min?: Maybe<ProjectAggregatorMin>;
  max?: Maybe<ProjectAggregatorMax>;
};

export type ProjectAggregatorSum = {
   __typename?: 'ProjectAggregatorSum';
  actual_duration?: Maybe<Scalars['Float']>;
};

export type ProjectAggregatorAvg = {
   __typename?: 'ProjectAggregatorAvg';
  actual_duration?: Maybe<Scalars['Float']>;
};

export type ProjectAggregatorMin = {
   __typename?: 'ProjectAggregatorMin';
  actual_duration?: Maybe<Scalars['Float']>;
};

export type ProjectAggregatorMax = {
   __typename?: 'ProjectAggregatorMax';
  actual_duration?: Maybe<Scalars['Float']>;
};

export type CreateProjectPayload = {
   __typename?: 'createProjectPayload';
  project?: Maybe<Project>;
};

export type UpdateProjectPayload = {
   __typename?: 'updateProjectPayload';
  project?: Maybe<Project>;
};

export type DeleteProjectPayload = {
   __typename?: 'deleteProjectPayload';
  project?: Maybe<Project>;
};

export type QuoteConnection = {
   __typename?: 'QuoteConnection';
  values?: Maybe<Array<Maybe<Quote>>>;
  groupBy?: Maybe<QuoteGroupBy>;
  aggregate?: Maybe<QuoteAggregator>;
};

export type QuoteGroupBy = {
   __typename?: 'QuoteGroupBy';
  id?: Maybe<Array<Maybe<QuoteConnectionId>>>;
  created_at?: Maybe<Array<Maybe<QuoteConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<QuoteConnectionUpdated_At>>>;
  project?: Maybe<Array<Maybe<QuoteConnectionProject>>>;
  name?: Maybe<Array<Maybe<QuoteConnectionName>>>;
  status?: Maybe<Array<Maybe<QuoteConnectionStatus>>>;
  nodes?: Maybe<Array<Maybe<QuoteConnectionNodes>>>;
  hours?: Maybe<Array<Maybe<QuoteConnectionHours>>>;
  design?: Maybe<Array<Maybe<QuoteConnectionDesign>>>;
  submitted_at?: Maybe<Array<Maybe<QuoteConnectionSubmitted_At>>>;
  approved_at?: Maybe<Array<Maybe<QuoteConnectionApproved_At>>>;
  changes?: Maybe<Array<Maybe<QuoteConnectionChanges>>>;
  created_by?: Maybe<Array<Maybe<QuoteConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<QuoteConnectionUpdated_By>>>;
};

export type QuoteConnectionId = {
   __typename?: 'QuoteConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionCreated_At = {
   __typename?: 'QuoteConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionUpdated_At = {
   __typename?: 'QuoteConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionProject = {
   __typename?: 'QuoteConnectionProject';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionName = {
   __typename?: 'QuoteConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionStatus = {
   __typename?: 'QuoteConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionNodes = {
   __typename?: 'QuoteConnectionNodes';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionHours = {
   __typename?: 'QuoteConnectionHours';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionDesign = {
   __typename?: 'QuoteConnectionDesign';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionSubmitted_At = {
   __typename?: 'QuoteConnectionSubmitted_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionApproved_At = {
   __typename?: 'QuoteConnectionApproved_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionChanges = {
   __typename?: 'QuoteConnectionChanges';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionCreated_By = {
   __typename?: 'QuoteConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteConnectionUpdated_By = {
   __typename?: 'QuoteConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuoteConnection>;
};

export type QuoteAggregator = {
   __typename?: 'QuoteAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<QuoteAggregatorSum>;
  avg?: Maybe<QuoteAggregatorAvg>;
  min?: Maybe<QuoteAggregatorMin>;
  max?: Maybe<QuoteAggregatorMax>;
};

export type QuoteAggregatorSum = {
   __typename?: 'QuoteAggregatorSum';
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
};

export type QuoteAggregatorAvg = {
   __typename?: 'QuoteAggregatorAvg';
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
};

export type QuoteAggregatorMin = {
   __typename?: 'QuoteAggregatorMin';
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
};

export type QuoteAggregatorMax = {
   __typename?: 'QuoteAggregatorMax';
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
};

export type CreateQuotePayload = {
   __typename?: 'createQuotePayload';
  quote?: Maybe<Quote>;
};

export type UpdateQuotePayload = {
   __typename?: 'updateQuotePayload';
  quote?: Maybe<Quote>;
};

export type DeleteQuotePayload = {
   __typename?: 'deleteQuotePayload';
  quote?: Maybe<Quote>;
};

export type Report = {
   __typename?: 'Report';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<UploadFile>;
  nps?: Maybe<UploadFile>;
  progress?: Maybe<UploadFile>;
  subscription?: Maybe<Subscription>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type Subscription = {
   __typename?: 'Subscription';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Subscription_Status>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  reports?: Maybe<Array<Maybe<Report>>>;
};


export type SubscriptionReportsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Subscription_Status {
  Dormant = 'DORMANT',
  Active = 'ACTIVE',
  Scheduled = 'SCHEDULED'
}

export type ReportConnection = {
   __typename?: 'ReportConnection';
  values?: Maybe<Array<Maybe<Report>>>;
  groupBy?: Maybe<ReportGroupBy>;
  aggregate?: Maybe<ReportAggregator>;
};

export type ReportGroupBy = {
   __typename?: 'ReportGroupBy';
  id?: Maybe<Array<Maybe<ReportConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ReportConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ReportConnectionUpdated_At>>>;
  date?: Maybe<Array<Maybe<ReportConnectionDate>>>;
  invoice?: Maybe<Array<Maybe<ReportConnectionInvoice>>>;
  nps?: Maybe<Array<Maybe<ReportConnectionNps>>>;
  progress?: Maybe<Array<Maybe<ReportConnectionProgress>>>;
  subscription?: Maybe<Array<Maybe<ReportConnectionSubscription>>>;
  created_by?: Maybe<Array<Maybe<ReportConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<ReportConnectionUpdated_By>>>;
};

export type ReportConnectionId = {
   __typename?: 'ReportConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreated_At = {
   __typename?: 'ReportConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdated_At = {
   __typename?: 'ReportConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionDate = {
   __typename?: 'ReportConnectionDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionInvoice = {
   __typename?: 'ReportConnectionInvoice';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionNps = {
   __typename?: 'ReportConnectionNps';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionProgress = {
   __typename?: 'ReportConnectionProgress';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionSubscription = {
   __typename?: 'ReportConnectionSubscription';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionCreated_By = {
   __typename?: 'ReportConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportConnectionUpdated_By = {
   __typename?: 'ReportConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReportConnection>;
};

export type ReportAggregator = {
   __typename?: 'ReportAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateReportPayload = {
   __typename?: 'createReportPayload';
  report?: Maybe<Report>;
};

export type UpdateReportPayload = {
   __typename?: 'updateReportPayload';
  report?: Maybe<Report>;
};

export type DeleteReportPayload = {
   __typename?: 'deleteReportPayload';
  report?: Maybe<Report>;
};

export type Settings = {
   __typename?: 'Settings';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  defaultRate?: Maybe<Scalars['Float']>;
  defaultBugRatio?: Maybe<Scalars['Float']>;
  defaultBufferRatio?: Maybe<Scalars['Float']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type UpdateSettingPayload = {
   __typename?: 'updateSettingPayload';
  setting?: Maybe<Settings>;
};

export type DeleteSettingPayload = {
   __typename?: 'deleteSettingPayload';
  setting?: Maybe<Settings>;
};

export type SubscriptionConnection = {
   __typename?: 'SubscriptionConnection';
  values?: Maybe<Array<Maybe<Subscription>>>;
  groupBy?: Maybe<SubscriptionGroupBy>;
  aggregate?: Maybe<SubscriptionAggregator>;
};

export type SubscriptionGroupBy = {
   __typename?: 'SubscriptionGroupBy';
  id?: Maybe<Array<Maybe<SubscriptionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubscriptionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubscriptionConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<SubscriptionConnectionName>>>;
  configuration?: Maybe<Array<Maybe<SubscriptionConnectionConfiguration>>>;
  client?: Maybe<Array<Maybe<SubscriptionConnectionClient>>>;
  start?: Maybe<Array<Maybe<SubscriptionConnectionStart>>>;
  end?: Maybe<Array<Maybe<SubscriptionConnectionEnd>>>;
  hours?: Maybe<Array<Maybe<SubscriptionConnectionHours>>>;
  status?: Maybe<Array<Maybe<SubscriptionConnectionStatus>>>;
  created_by?: Maybe<Array<Maybe<SubscriptionConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<SubscriptionConnectionUpdated_By>>>;
};

export type SubscriptionConnectionId = {
   __typename?: 'SubscriptionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionCreated_At = {
   __typename?: 'SubscriptionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionUpdated_At = {
   __typename?: 'SubscriptionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionName = {
   __typename?: 'SubscriptionConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionConfiguration = {
   __typename?: 'SubscriptionConnectionConfiguration';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionClient = {
   __typename?: 'SubscriptionConnectionClient';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionStart = {
   __typename?: 'SubscriptionConnectionStart';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionEnd = {
   __typename?: 'SubscriptionConnectionEnd';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionHours = {
   __typename?: 'SubscriptionConnectionHours';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionStatus = {
   __typename?: 'SubscriptionConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionCreated_By = {
   __typename?: 'SubscriptionConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionUpdated_By = {
   __typename?: 'SubscriptionConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionAggregator = {
   __typename?: 'SubscriptionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateSubscriptionPayload = {
   __typename?: 'createSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type UpdateSubscriptionPayload = {
   __typename?: 'updateSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type DeleteSubscriptionPayload = {
   __typename?: 'deleteSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type Template = {
   __typename?: 'Template';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  flow?: Maybe<Scalars['JSON']>;
  hours?: Maybe<Scalars['Float']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type TemplateConnection = {
   __typename?: 'TemplateConnection';
  values?: Maybe<Array<Maybe<Template>>>;
  groupBy?: Maybe<TemplateGroupBy>;
  aggregate?: Maybe<TemplateAggregator>;
};

export type TemplateGroupBy = {
   __typename?: 'TemplateGroupBy';
  id?: Maybe<Array<Maybe<TemplateConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TemplateConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TemplateConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TemplateConnectionName>>>;
  flow?: Maybe<Array<Maybe<TemplateConnectionFlow>>>;
  hours?: Maybe<Array<Maybe<TemplateConnectionHours>>>;
  created_by?: Maybe<Array<Maybe<TemplateConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<TemplateConnectionUpdated_By>>>;
};

export type TemplateConnectionId = {
   __typename?: 'TemplateConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionCreated_At = {
   __typename?: 'TemplateConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionUpdated_At = {
   __typename?: 'TemplateConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionName = {
   __typename?: 'TemplateConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionFlow = {
   __typename?: 'TemplateConnectionFlow';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionHours = {
   __typename?: 'TemplateConnectionHours';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionCreated_By = {
   __typename?: 'TemplateConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateConnectionUpdated_By = {
   __typename?: 'TemplateConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TemplateConnection>;
};

export type TemplateAggregator = {
   __typename?: 'TemplateAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<TemplateAggregatorSum>;
  avg?: Maybe<TemplateAggregatorAvg>;
  min?: Maybe<TemplateAggregatorMin>;
  max?: Maybe<TemplateAggregatorMax>;
};

export type TemplateAggregatorSum = {
   __typename?: 'TemplateAggregatorSum';
  hours?: Maybe<Scalars['Float']>;
};

export type TemplateAggregatorAvg = {
   __typename?: 'TemplateAggregatorAvg';
  hours?: Maybe<Scalars['Float']>;
};

export type TemplateAggregatorMin = {
   __typename?: 'TemplateAggregatorMin';
  hours?: Maybe<Scalars['Float']>;
};

export type TemplateAggregatorMax = {
   __typename?: 'TemplateAggregatorMax';
  hours?: Maybe<Scalars['Float']>;
};

export type CreateTemplatePayload = {
   __typename?: 'createTemplatePayload';
  template?: Maybe<Template>;
};

export type UpdateTemplatePayload = {
   __typename?: 'updateTemplatePayload';
  template?: Maybe<Template>;
};

export type DeleteTemplatePayload = {
   __typename?: 'deleteTemplatePayload';
  template?: Maybe<Template>;
};

export type Terms = {
   __typename?: 'Terms';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  document?: Maybe<UploadFile>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type TermsConnection = {
   __typename?: 'TermsConnection';
  values?: Maybe<Array<Maybe<Terms>>>;
  groupBy?: Maybe<TermsGroupBy>;
  aggregate?: Maybe<TermsAggregator>;
};

export type TermsGroupBy = {
   __typename?: 'TermsGroupBy';
  id?: Maybe<Array<Maybe<TermsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TermsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TermsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TermsConnectionName>>>;
  document?: Maybe<Array<Maybe<TermsConnectionDocument>>>;
  created_by?: Maybe<Array<Maybe<TermsConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<TermsConnectionUpdated_By>>>;
};

export type TermsConnectionId = {
   __typename?: 'TermsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsConnectionCreated_At = {
   __typename?: 'TermsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsConnectionUpdated_At = {
   __typename?: 'TermsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsConnectionName = {
   __typename?: 'TermsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsConnectionDocument = {
   __typename?: 'TermsConnectionDocument';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsConnectionCreated_By = {
   __typename?: 'TermsConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsConnectionUpdated_By = {
   __typename?: 'TermsConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TermsConnection>;
};

export type TermsAggregator = {
   __typename?: 'TermsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateTermPayload = {
   __typename?: 'createTermPayload';
  term?: Maybe<Terms>;
};

export type UpdateTermPayload = {
   __typename?: 'updateTermPayload';
  term?: Maybe<Terms>;
};

export type DeleteTermPayload = {
   __typename?: 'deleteTermPayload';
  term?: Maybe<Terms>;
};

export type UploadFileConnection = {
   __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileGroupBy = {
   __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  created_by?: Maybe<Array<Maybe<UploadFileConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UploadFileConnectionUpdated_By>>>;
};

export type UploadFileConnectionId = {
   __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
   __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
   __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
   __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
   __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
   __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
   __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
   __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
   __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
   __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
   __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
   __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
   __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
   __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
   __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
   __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
   __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_By = {
   __typename?: 'UploadFileConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_By = {
   __typename?: 'UploadFileConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileAggregator = {
   __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorSum = {
   __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorAvg = {
   __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
   __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
   __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsRoleConnection = {
   __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleGroupBy = {
   __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionUpdated_By>>>;
};

export type UsersPermissionsRoleConnectionId = {
   __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
   __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
   __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
   __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionCreated_By = {
   __typename?: 'UsersPermissionsRoleConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionUpdated_By = {
   __typename?: 'UsersPermissionsRoleConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleAggregator = {
   __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRolePayload = {
   __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRolePayload = {
   __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRolePayload = {
   __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserConnection = {
   __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserGroupBy = {
   __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  phoneNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoneNumber>>>;
  profilePicture?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProfilePicture>>>;
  fullName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFullName>>>;
  oauth?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOauth>>>;
  memberID?: Maybe<Array<Maybe<UsersPermissionsUserConnectionMemberId>>>;
  client?: Maybe<Array<Maybe<UsersPermissionsUserConnectionClient>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_By>>>;
};

export type UsersPermissionsUserConnectionId = {
   __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
   __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
   __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
   __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
   __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
   __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
   __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
   __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
   __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPhoneNumber = {
   __typename?: 'UsersPermissionsUserConnectionPhoneNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProfilePicture = {
   __typename?: 'UsersPermissionsUserConnectionProfilePicture';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionFullName = {
   __typename?: 'UsersPermissionsUserConnectionFullName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionOauth = {
   __typename?: 'UsersPermissionsUserConnectionOauth';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionMemberId = {
   __typename?: 'UsersPermissionsUserConnectionMemberID';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionClient = {
   __typename?: 'UsersPermissionsUserConnectionClient';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_By = {
   __typename?: 'UsersPermissionsUserConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_By = {
   __typename?: 'UsersPermissionsUserConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserAggregator = {
   __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateUserPayload = {
   __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserPayload = {
   __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserPayload = {
   __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type ComponentContactContact = {
   __typename?: 'ComponentContactContact';
  id: Scalars['ID'];
  fullName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  cellphone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ComponentQuotationLineItem = {
   __typename?: 'ComponentQuotationLineItem';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
};

export type Mutation = {
   __typename?: 'Mutation';
  createClient?: Maybe<CreateClientPayload>;
  updateClient?: Maybe<UpdateClientPayload>;
  deleteClient?: Maybe<DeleteClientPayload>;
  createDocument?: Maybe<CreateDocumentPayload>;
  updateDocument?: Maybe<UpdateDocumentPayload>;
  deleteDocument?: Maybe<DeleteDocumentPayload>;
  createFeatureTemplate?: Maybe<CreateFeatureTemplatePayload>;
  updateFeatureTemplate?: Maybe<UpdateFeatureTemplatePayload>;
  deleteFeatureTemplate?: Maybe<DeleteFeatureTemplatePayload>;
  createProject?: Maybe<CreateProjectPayload>;
  updateProject?: Maybe<UpdateProjectPayload>;
  deleteProject?: Maybe<DeleteProjectPayload>;
  createQuote?: Maybe<CreateQuotePayload>;
  updateQuote?: Maybe<UpdateQuotePayload>;
  deleteQuote?: Maybe<DeleteQuotePayload>;
  createReport?: Maybe<CreateReportPayload>;
  updateReport?: Maybe<UpdateReportPayload>;
  deleteReport?: Maybe<DeleteReportPayload>;
  updateSetting?: Maybe<UpdateSettingPayload>;
  deleteSetting?: Maybe<DeleteSettingPayload>;
  createSubscription?: Maybe<CreateSubscriptionPayload>;
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  deleteSubscription?: Maybe<DeleteSubscriptionPayload>;
  createTemplate?: Maybe<CreateTemplatePayload>;
  updateTemplate?: Maybe<UpdateTemplatePayload>;
  deleteTemplate?: Maybe<DeleteTemplatePayload>;
  createTerm?: Maybe<CreateTermPayload>;
  updateTerm?: Maybe<UpdateTermPayload>;
  deleteTerm?: Maybe<DeleteTermPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  createLSADoc?: Maybe<DocTemplate>;
  createSolutionOverview?: Maybe<DocTemplate>;
  createPMEDoc?: Maybe<DocTemplate>;
  createCustomQuote?: Maybe<Quote>;
  editCustomQuote?: Maybe<Quote>;
  cloneQuote?: Maybe<Quote>;
  quoteReviewStatus?: Maybe<Quote>;
  quoteApprovedStatus?: Maybe<Quote>;
  sendReportEmail?: Maybe<EmailStatus>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  inviteMember?: Maybe<UsersPermissionsUser>;
};


export type MutationCreateClientArgs = {
  input?: Maybe<CreateClientInput>;
};


export type MutationUpdateClientArgs = {
  input?: Maybe<UpdateClientInput>;
};


export type MutationDeleteClientArgs = {
  input?: Maybe<DeleteClientInput>;
};


export type MutationCreateDocumentArgs = {
  input?: Maybe<CreateDocumentInput>;
};


export type MutationUpdateDocumentArgs = {
  input?: Maybe<UpdateDocumentInput>;
};


export type MutationDeleteDocumentArgs = {
  input?: Maybe<DeleteDocumentInput>;
};


export type MutationCreateFeatureTemplateArgs = {
  input?: Maybe<CreateFeatureTemplateInput>;
};


export type MutationUpdateFeatureTemplateArgs = {
  input?: Maybe<UpdateFeatureTemplateInput>;
};


export type MutationDeleteFeatureTemplateArgs = {
  input?: Maybe<DeleteFeatureTemplateInput>;
};


export type MutationCreateProjectArgs = {
  input?: Maybe<CreateProjectInput>;
};


export type MutationUpdateProjectArgs = {
  input?: Maybe<UpdateProjectInput>;
};


export type MutationDeleteProjectArgs = {
  input?: Maybe<DeleteProjectInput>;
};


export type MutationCreateQuoteArgs = {
  input?: Maybe<CreateQuoteInput>;
};


export type MutationUpdateQuoteArgs = {
  input?: Maybe<UpdateQuoteInput>;
};


export type MutationDeleteQuoteArgs = {
  input?: Maybe<DeleteQuoteInput>;
};


export type MutationCreateReportArgs = {
  input?: Maybe<CreateReportInput>;
};


export type MutationUpdateReportArgs = {
  input?: Maybe<UpdateReportInput>;
};


export type MutationDeleteReportArgs = {
  input?: Maybe<DeleteReportInput>;
};


export type MutationUpdateSettingArgs = {
  input?: Maybe<UpdateSettingInput>;
};


export type MutationCreateSubscriptionArgs = {
  input?: Maybe<CreateSubscriptionInput>;
};


export type MutationUpdateSubscriptionArgs = {
  input?: Maybe<UpdateSubscriptionInput>;
};


export type MutationDeleteSubscriptionArgs = {
  input?: Maybe<DeleteSubscriptionInput>;
};


export type MutationCreateTemplateArgs = {
  input?: Maybe<CreateTemplateInput>;
};


export type MutationUpdateTemplateArgs = {
  input?: Maybe<UpdateTemplateInput>;
};


export type MutationDeleteTemplateArgs = {
  input?: Maybe<DeleteTemplateInput>;
};


export type MutationCreateTermArgs = {
  input?: Maybe<CreateTermInput>;
};


export type MutationUpdateTermArgs = {
  input?: Maybe<UpdateTermInput>;
};


export type MutationDeleteTermArgs = {
  input?: Maybe<DeleteTermInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationCreateLsaDocArgs = {
  data?: Maybe<LsaInput>;
};


export type MutationCreateSolutionOverviewArgs = {
  id: Scalars['ID'];
};


export type MutationCreatePmeDocArgs = {
  id: Scalars['ID'];
};


export type MutationCreateCustomQuoteArgs = {
  data?: Maybe<CustomQuoteInput>;
};


export type MutationEditCustomQuoteArgs = {
  data?: Maybe<EditCustomQuoteInput>;
};


export type MutationCloneQuoteArgs = {
  id: Scalars['ID'];
};


export type MutationQuoteReviewStatusArgs = {
  id: Scalars['ID'];
};


export type MutationQuoteApprovedStatusArgs = {
  id: Scalars['ID'];
};


export type MutationSendReportEmailArgs = {
  data?: Maybe<SendReportEmailInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationInviteMemberArgs = {
  data?: Maybe<InviteMemberInput>;
};

export type CreateClientInput = {
  data?: Maybe<ClientInput>;
};

export type ClientInput = {
  companyName?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industry?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<Scalars['ID']>>>;
  subscriptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  colour?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateClientInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditClientInput>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type EditClientInput = {
  companyName?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  industry?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<Scalars['ID']>>>;
  subscriptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  colour?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteClientInput = {
  where?: Maybe<InputId>;
};

export type CreateDocumentInput = {
  data?: Maybe<DocumentInput>;
};

export type DocumentInput = {
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['ID']>;
  project?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateDocumentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDocumentInput>;
};

export type EditDocumentInput = {
  name?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['ID']>;
  project?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteDocumentInput = {
  where?: Maybe<InputId>;
};

export type CreateFeatureTemplateInput = {
  data?: Maybe<FeatureTemplateInput>;
};

export type FeatureTemplateInput = {
  name?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['Float']>;
  thumbnail?: Maybe<Scalars['ID']>;
  integration?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  desktop?: Maybe<Scalars['ID']>;
  mobile?: Maybe<Scalars['ID']>;
  custom?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateFeatureTemplateInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFeatureTemplateInput>;
};

export type EditFeatureTemplateInput = {
  name?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['Float']>;
  thumbnail?: Maybe<Scalars['ID']>;
  integration?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  desktop?: Maybe<Scalars['ID']>;
  mobile?: Maybe<Scalars['ID']>;
  custom?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteFeatureTemplateInput = {
  where?: Maybe<InputId>;
};

export type CreateProjectInput = {
  data?: Maybe<ProjectInput>;
};

export type ProjectInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  rep?: Maybe<Scalars['ID']>;
  quotes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  problem?: Maybe<Scalars['String']>;
  solution?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['String']>;
  need?: Maybe<Scalars['String']>;
  geography?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['Boolean']>;
  actual_duration?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Project_Status>;
  stakeholders?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateProjectInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProjectInput>;
};

export type EditProjectInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  rep?: Maybe<Scalars['ID']>;
  quotes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  problem?: Maybe<Scalars['String']>;
  solution?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['String']>;
  need?: Maybe<Scalars['String']>;
  geography?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['Boolean']>;
  actual_duration?: Maybe<Scalars['Int']>;
  status?: Maybe<Enum_Project_Status>;
  stakeholders?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProjectInput = {
  where?: Maybe<InputId>;
};

export type CreateQuoteInput = {
  data?: Maybe<QuoteInput>;
};

export type QuoteInput = {
  project?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Quote_Status>;
  nodes?: Maybe<Scalars['JSON']>;
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
  submitted_at?: Maybe<Scalars['DateTime']>;
  approved_at?: Maybe<Scalars['DateTime']>;
  changes?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateQuoteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditQuoteInput>;
};

export type EditQuoteInput = {
  project?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Quote_Status>;
  nodes?: Maybe<Scalars['JSON']>;
  hours?: Maybe<Scalars['Float']>;
  design?: Maybe<Scalars['Float']>;
  submitted_at?: Maybe<Scalars['DateTime']>;
  approved_at?: Maybe<Scalars['DateTime']>;
  changes?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteQuoteInput = {
  where?: Maybe<InputId>;
};

export type CreateReportInput = {
  data?: Maybe<ReportInput>;
};

export type ReportInput = {
  date?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<Scalars['ID']>;
  nps?: Maybe<Scalars['ID']>;
  progress?: Maybe<Scalars['ID']>;
  subscription?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateReportInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReportInput>;
};

export type EditReportInput = {
  date?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<Scalars['ID']>;
  nps?: Maybe<Scalars['ID']>;
  progress?: Maybe<Scalars['ID']>;
  subscription?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteReportInput = {
  where?: Maybe<InputId>;
};

export type UpdateSettingInput = {
  data?: Maybe<EditSettingInput>;
};

export type EditSettingInput = {
  defaultRate?: Maybe<Scalars['Float']>;
  defaultBugRatio?: Maybe<Scalars['Float']>;
  defaultBufferRatio?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateSubscriptionInput = {
  data?: Maybe<SubscriptionInput>;
};

export type SubscriptionInput = {
  name?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  client?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Subscription_Status>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateSubscriptionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubscriptionInput>;
};

export type EditSubscriptionInput = {
  name?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  client?: Maybe<Scalars['ID']>;
  reports?: Maybe<Array<Maybe<Scalars['ID']>>>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Subscription_Status>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteSubscriptionInput = {
  where?: Maybe<InputId>;
};

export type CreateTemplateInput = {
  data?: Maybe<TemplateInput>;
};

export type TemplateInput = {
  name?: Maybe<Scalars['String']>;
  flow?: Maybe<Scalars['JSON']>;
  hours?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateTemplateInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTemplateInput>;
};

export type EditTemplateInput = {
  name?: Maybe<Scalars['String']>;
  flow?: Maybe<Scalars['JSON']>;
  hours?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteTemplateInput = {
  where?: Maybe<InputId>;
};

export type CreateTermInput = {
  data?: Maybe<TermInput>;
};

export type TermInput = {
  name?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateTermInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTermInput>;
};

export type EditTermInput = {
  name?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteTermInput = {
  where?: Maybe<InputId>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  projects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  fullName?: Maybe<Scalars['String']>;
  oauth?: Maybe<Scalars['JSON']>;
  memberID?: Maybe<Scalars['String']>;
  clientprojects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  client?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  projects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  fullName?: Maybe<Scalars['String']>;
  oauth?: Maybe<Scalars['JSON']>;
  memberID?: Maybe<Scalars['String']>;
  clientprojects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  client?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type LsaInput = {
  client?: Maybe<Scalars['String']>;
  project?: Maybe<Scalars['String']>;
  numPlatforms?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
};

export type CustomQuoteInput = {
  name: Scalars['String'];
  platforms?: Maybe<Array<Maybe<CustomPlatform>>>;
  project: Scalars['ID'];
  template?: Maybe<Scalars['String']>;
};

export type CustomPlatform = {
  name: Scalars['String'];
  description: Scalars['String'];
  type: Scalars['String'];
  parent: Scalars['ID'];
};

export type EditCustomQuoteInput = {
  id: Scalars['ID'];
  addPlatforms?: Maybe<Array<Maybe<CustomPlatform>>>;
  removePlatforms?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type SendReportEmailInput = {
  report?: Maybe<Scalars['ID']>;
};


export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type InviteMemberInput = {
  client?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
};

export type SettingInput = {
  defaultRate?: Maybe<Scalars['Float']>;
  defaultBugRatio?: Maybe<Scalars['Float']>;
  defaultBufferRatio?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentContactContactInput = {
  fullName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  cellphone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type EditComponentContactContactInput = {
  id?: Maybe<Scalars['ID']>;
  fullName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  cellphone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ComponentQuotationLineItemInput = {
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
};

export type EditComponentQuotationLineItemInput = {
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
};




export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CloneQuoteMutationVariables = {
  id: Scalars['ID'];
};


export type CloneQuoteMutation = (
  { __typename?: 'Mutation' }
  & { cloneQuote?: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id' | 'name' | 'status' | 'nodes' | 'hours' | 'design' | 'created_at' | 'updated_at'>
  )> }
);

export type CreateClientMutationVariables = {
  data: ClientInput;
};


export type CreateClientMutation = (
  { __typename?: 'Mutation' }
  & { createClient?: Maybe<(
    { __typename?: 'createClientPayload' }
    & { client?: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'companyName' | 'website' | 'logo' | 'industry' | 'country' | 'size'>
    )> }
  )> }
);

export type CreateCustomQuoteMutationVariables = {
  data: CustomQuoteInput;
};


export type CreateCustomQuoteMutation = (
  { __typename?: 'Mutation' }
  & { createCustomQuote?: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id' | 'created_at' | 'updated_at' | 'name' | 'status' | 'nodes' | 'hours'>
  )> }
);

export type CreateDocumentMutationVariables = {
  data?: Maybe<DocumentInput>;
};


export type CreateDocumentMutation = (
  { __typename?: 'Mutation' }
  & { createDocument?: Maybe<(
    { __typename?: 'createDocumentPayload' }
    & { document?: Maybe<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'created_at' | 'updated_at' | 'name' | 'link'>
      & { file?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )> }
  )> }
);

export type CreateFeatureTemplateMutationVariables = {
  data: FeatureTemplateInput;
};


export type CreateFeatureTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createFeatureTemplate?: Maybe<(
    { __typename?: 'createFeatureTemplatePayload' }
    & { featureTemplate?: Maybe<(
      { __typename?: 'FeatureTemplate' }
      & Pick<FeatureTemplate, 'id'>
    )> }
  )> }
);

export type CreateLsaDocMutationVariables = {
  data?: Maybe<LsaInput>;
};


export type CreateLsaDocMutation = (
  { __typename?: 'Mutation' }
  & { createLSADoc?: Maybe<(
    { __typename?: 'DocTemplate' }
    & Pick<DocTemplate, 'url'>
  )> }
);

export type CreatePmeDocMutationVariables = {
  id: Scalars['ID'];
};


export type CreatePmeDocMutation = (
  { __typename?: 'Mutation' }
  & { createPMEDoc?: Maybe<(
    { __typename?: 'DocTemplate' }
    & Pick<DocTemplate, 'url'>
  )> }
);

export type CreateProjectMutationVariables = {
  data: ProjectInput;
};


export type CreateProjectMutation = (
  { __typename?: 'Mutation' }
  & { createProject?: Maybe<(
    { __typename?: 'createProjectPayload' }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id' | 'name' | 'description'>
    )> }
  )> }
);

export type CreateQuoteMutationVariables = {
  data: QuoteInput;
};


export type CreateQuoteMutation = (
  { __typename?: 'Mutation' }
  & { createQuote?: Maybe<(
    { __typename?: 'createQuotePayload' }
    & { quote?: Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'created_at' | 'updated_at' | 'name' | 'status'>
    )> }
  )> }
);

export type CreateReportMutationVariables = {
  data: ReportInput;
};


export type CreateReportMutation = (
  { __typename?: 'Mutation' }
  & { createReport?: Maybe<(
    { __typename?: 'createReportPayload' }
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id'>
    )> }
  )> }
);

export type CreateSolutionOverviewMutationVariables = {
  id: Scalars['ID'];
};


export type CreateSolutionOverviewMutation = (
  { __typename?: 'Mutation' }
  & { createSolutionOverview?: Maybe<(
    { __typename?: 'DocTemplate' }
    & Pick<DocTemplate, 'url'>
  )> }
);

export type CreateSubscriptionMutationVariables = {
  data: SubscriptionInput;
};


export type CreateSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { createSubscription?: Maybe<(
    { __typename?: 'createSubscriptionPayload' }
    & { subscription?: Maybe<(
      { __typename?: 'Subscription' }
      & Pick<Subscription, 'id'>
    )> }
  )> }
);

export type CreateTemplateMutationVariables = {
  data: TemplateInput;
};


export type CreateTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createTemplate?: Maybe<(
    { __typename?: 'createTemplatePayload' }
    & { template?: Maybe<(
      { __typename?: 'Template' }
      & Pick<Template, 'id' | 'name' | 'flow' | 'hours'>
    )> }
  )> }
);

export type CreateUserMutationVariables = {
  input?: Maybe<CreateUserInput>;
};


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'createUserPayload' }
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'username' | 'email' | 'confirmed' | 'blocked'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
      )> }
    )> }
  )> }
);

export type EditCustomQuoteMutationVariables = {
  data: EditCustomQuoteInput;
};


export type EditCustomQuoteMutation = (
  { __typename?: 'Mutation' }
  & { editCustomQuote?: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id'>
  )> }
);

export type InviteMemberMutationVariables = {
  data?: Maybe<InviteMemberInput>;
};


export type InviteMemberMutation = (
  { __typename?: 'Mutation' }
  & { inviteMember?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id'>
  )> }
);

export type QuoteApprovedStatusMutationVariables = {
  id: Scalars['ID'];
};


export type QuoteApprovedStatusMutation = (
  { __typename?: 'Mutation' }
  & { quoteApprovedStatus?: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'status'>
  )> }
);

export type QuoteReviewStatusMutationVariables = {
  id: Scalars['ID'];
};


export type QuoteReviewStatusMutation = (
  { __typename?: 'Mutation' }
  & { quoteReviewStatus?: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'status'>
  )> }
);

export type SendReportEmailMutationVariables = {
  data?: Maybe<SendReportEmailInput>;
};


export type SendReportEmailMutation = (
  { __typename?: 'Mutation' }
  & { sendReportEmail?: Maybe<(
    { __typename?: 'EmailStatus' }
    & Pick<EmailStatus, 'sent'>
  )> }
);

export type UpdateClientMutationVariables = {
  id: Scalars['ID'];
  data: EditClientInput;
};


export type UpdateClientMutation = (
  { __typename?: 'Mutation' }
  & { updateClient?: Maybe<(
    { __typename?: 'updateClientPayload' }
    & { client?: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id'>
    )> }
  )> }
);

export type UpdateProjectMutationVariables = {
  id: Scalars['ID'];
  data: EditProjectInput;
};


export type UpdateProjectMutation = (
  { __typename?: 'Mutation' }
  & { updateProject?: Maybe<(
    { __typename?: 'updateProjectPayload' }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id'>
      & { stakeholders?: Maybe<Array<Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'id'>
      )>>> }
    )> }
  )> }
);

export type UpdateQuoteMutationVariables = {
  id: Scalars['ID'];
  data: EditQuoteInput;
};


export type UpdateQuoteMutation = (
  { __typename?: 'Mutation' }
  & { updateQuote?: Maybe<(
    { __typename?: 'updateQuotePayload' }
    & { quote?: Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'created_at' | 'updated_at' | 'submitted_at' | 'approved_at' | 'name' | 'nodes' | 'changes' | 'hours' | 'design'>
    )> }
  )> }
);

export type UpdateReportMutationVariables = {
  id: Scalars['ID'];
  data: EditReportInput;
};


export type UpdateReportMutation = (
  { __typename?: 'Mutation' }
  & { updateReport?: Maybe<(
    { __typename?: 'updateReportPayload' }
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id'>
    )> }
  )> }
);

export type ClientQueryVariables = {
  id: Scalars['ID'];
};


export type ClientQuery = (
  { __typename?: 'Query' }
  & { client?: Maybe<(
    { __typename?: 'Client' }
    & Pick<Client, 'id' | 'created_at' | 'updated_at' | 'companyName' | 'website' | 'logo' | 'industry' | 'country' | 'size' | 'colour'>
    & { avatar?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, projects?: Maybe<Array<Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id' | 'name'>
    )>>> }
  )> }
);

export type ClientsQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ClientsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'totalClients'>
  & { clients?: Maybe<Array<Maybe<(
    { __typename?: 'Client' }
    & Pick<Client, 'id' | 'created_at' | 'updated_at' | 'companyName' | 'website' | 'logo' | 'industry' | 'country' | 'size' | 'colour'>
    & { avatar?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, projects?: Maybe<Array<Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id' | 'name'>
    )>>> }
  )>>> }
);

export type GetDashboardQueryVariables = {};


export type GetDashboardQuery = (
  { __typename?: 'Query' }
  & { getDashboard?: Maybe<(
    { __typename?: 'DashboardOutput' }
    & { reviewQuotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'name' | 'hours' | 'created_at' | 'updated_at'>
    )>>>, recentApprovedQuotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'name' | 'hours' | 'created_at' | 'updated_at'>
    )>>>, createdQuotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'created_at'>
    )>>>, submittedQuotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'submitted_at'>
    )>>>, approvedQuotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'approved_at'>
    )>>> }
  )> }
);

export type DocumentsQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type DocumentsQuery = (
  { __typename?: 'Query' }
  & { documents?: Maybe<Array<Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'id' | 'created_at' | 'updated_at' | 'name' | 'link'>
    & { file?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>> }
);

export type FeatureTemplateQueryVariables = {
  id: Scalars['ID'];
};


export type FeatureTemplateQuery = (
  { __typename?: 'Query' }
  & { featureTemplate?: Maybe<(
    { __typename?: 'FeatureTemplate' }
    & Pick<FeatureTemplate, 'id' | 'integration' | 'custom'>
    & { thumbnail?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, desktop?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, mobile?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )> }
);

export type FeatureTemplatesQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type FeatureTemplatesQuery = (
  { __typename?: 'Query' }
  & { featureTemplates?: Maybe<Array<Maybe<(
    { __typename?: 'FeatureTemplate' }
    & Pick<FeatureTemplate, 'id' | 'name' | 'description' | 'hours' | 'integration' | 'custom'>
  )>>> }
);

export type ProjectQueryVariables = {
  id: Scalars['ID'];
};


export type ProjectQuery = (
  { __typename?: 'Query' }
  & { project?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id' | 'created_at' | 'updated_at' | 'name' | 'description' | 'problem' | 'solution' | 'market' | 'industry' | 'users' | 'need' | 'geography' | 'frequency' | 'status' | 'actual_duration'>
    & { logo?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, quotes?: Maybe<Array<Maybe<(
      { __typename?: 'Quote' }
      & Pick<Quote, 'id' | 'created_at' | 'updated_at' | 'name' | 'hours' | 'status'>
    )>>>, client?: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'companyName' | 'logo'>
    )>, stakeholders?: Maybe<Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'username' | 'email' | 'phoneNumber'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'name'>
      )> }
    )>>> }
  )> }
);

export type ProjectsQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProjectsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'totalProjects'>
  & { projects?: Maybe<Array<Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'id' | 'created_at' | 'updated_at' | 'name' | 'description' | 'status'>
    & { rep?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'fullName' | 'username'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'name'>
      )> }
    )>, client?: Maybe<(
      { __typename?: 'Client' }
      & Pick<Client, 'id' | 'companyName' | 'logo'>
    )>, stakeholders?: Maybe<Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'id' | 'username' | 'email'>
    )>>> }
  )>>> }
);

export type QuoteQueryVariables = {
  id: Scalars['ID'];
};


export type QuoteQuery = (
  { __typename?: 'Query' }
  & { quote?: Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id' | 'created_at' | 'updated_at' | 'approved_at' | 'submitted_at' | 'name' | 'status' | 'nodes' | 'hours' | 'design' | 'changes'>
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'id' | 'name' | 'partner'>
      & { client?: Maybe<(
        { __typename?: 'Client' }
        & Pick<Client, 'companyName'>
      )> }
    )> }
  )> }
);

export type QuotesQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuotesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'totalQuotes'>
  & { quotes?: Maybe<Array<Maybe<(
    { __typename?: 'Quote' }
    & Pick<Quote, 'id' | 'created_at' | 'updated_at' | 'approved_at' | 'submitted_at' | 'name' | 'status' | 'hours' | 'design'>
  )>>> }
);

export type ReportsQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ReportsQuery = (
  { __typename?: 'Query' }
  & { reports?: Maybe<Array<Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'id' | 'created_at' | 'updated_at' | 'date'>
    & { subscription?: Maybe<(
      { __typename?: 'Subscription' }
      & Pick<Subscription, 'id' | 'name'>
    )>, invoice?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, nps?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, progress?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>> }
);

export type SubscriptionQueryVariables = {
  id: Scalars['ID'];
};


export type SubscriptionQuery = (
  { __typename?: 'Query' }
  & { subscription?: Maybe<(
    { __typename?: 'Subscription' }
    & Pick<Subscription, 'id' | 'created_at' | 'updated_at' | 'name' | 'hours' | 'start' | 'end' | 'status'>
    & { reports?: Maybe<Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'created_at' | 'updated_at' | 'date'>
      & { invoice?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, nps?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )>, progress?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'id' | 'url'>
      )> }
    )>>> }
  )> }
);

export type SubscriptionsQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type SubscriptionsQuery = (
  { __typename?: 'Query' }
  & { subscriptions?: Maybe<Array<Maybe<(
    { __typename?: 'Subscription' }
    & Pick<Subscription, 'id' | 'created_at' | 'updated_at' | 'name' | 'hours' | 'start' | 'end' | 'status'>
  )>>> }
);

export type TemplateQueryVariables = {
  id: Scalars['ID'];
};


export type TemplateQuery = (
  { __typename?: 'Query' }
  & { template?: Maybe<(
    { __typename?: 'Template' }
    & Pick<Template, 'id' | 'name' | 'flow' | 'hours'>
  )> }
);

export type TemplatesQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TemplatesQuery = (
  { __typename?: 'Query' }
  & { templates?: Maybe<Array<Maybe<(
    { __typename?: 'Template' }
    & Pick<Template, 'id' | 'name' | 'flow' | 'hours'>
  )>>> }
);

export type TermsQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type TermsQuery = (
  { __typename?: 'Query' }
  & { terms?: Maybe<Array<Maybe<(
    { __typename?: 'Terms' }
    & Pick<Terms, 'id' | 'created_at' | 'updated_at' | 'name'>
    & { document?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>> }
);

export type UsersQueryVariables = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<Array<Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'created_at' | 'updated_at' | 'username' | 'email' | 'provider' | 'confirmed' | 'blocked' | 'phoneNumber' | 'fullName'>
    & { role?: Maybe<(
      { __typename?: 'UsersPermissionsRole' }
      & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
    )>, profilePicture?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )> }
  )>>> }
);


export const CloneQuoteDocument = gql`
    mutation cloneQuote($id: ID!) {
  cloneQuote(id: $id) {
    id
    name
    status
    nodes
    hours
    design
    created_at
    updated_at
  }
}
    `;
export type CloneQuoteMutationFn = ApolloReactCommon.MutationFunction<CloneQuoteMutation, CloneQuoteMutationVariables>;
export type CloneQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CloneQuoteMutation, CloneQuoteMutationVariables>, 'mutation'>;

    export const CloneQuoteComponent = (props: CloneQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<CloneQuoteMutation, CloneQuoteMutationVariables> mutation={CloneQuoteDocument} {...props} />
    );
    
export type CloneQuoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CloneQuoteMutation, CloneQuoteMutationVariables>
    } & TChildProps;
export function withCloneQuote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CloneQuoteMutation,
  CloneQuoteMutationVariables,
  CloneQuoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CloneQuoteMutation, CloneQuoteMutationVariables, CloneQuoteProps<TChildProps, TDataName>>(CloneQuoteDocument, {
      alias: 'cloneQuote',
      ...operationOptions
    });
};

/**
 * __useCloneQuoteMutation__
 *
 * To run a mutation, you first call `useCloneQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneQuoteMutation, { data, loading, error }] = useCloneQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneQuoteMutation, CloneQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<CloneQuoteMutation, CloneQuoteMutationVariables>(CloneQuoteDocument, baseOptions);
      }
export type CloneQuoteMutationHookResult = ReturnType<typeof useCloneQuoteMutation>;
export type CloneQuoteMutationResult = ApolloReactCommon.MutationResult<CloneQuoteMutation>;
export type CloneQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneQuoteMutation, CloneQuoteMutationVariables>;
export const CreateClientDocument = gql`
    mutation createClient($data: ClientInput!) {
  createClient(input: {data: $data}) {
    client {
      id
      companyName
      website
      logo
      industry
      country
      size
    }
  }
}
    `;
export type CreateClientMutationFn = ApolloReactCommon.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;
export type CreateClientComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateClientMutation, CreateClientMutationVariables>, 'mutation'>;

    export const CreateClientComponent = (props: CreateClientComponentProps) => (
      <ApolloReactComponents.Mutation<CreateClientMutation, CreateClientMutationVariables> mutation={CreateClientDocument} {...props} />
    );
    
export type CreateClientProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateClientMutation, CreateClientMutationVariables>
    } & TChildProps;
export function withCreateClient<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateClientMutation,
  CreateClientMutationVariables,
  CreateClientProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateClientMutation, CreateClientMutationVariables, CreateClientProps<TChildProps, TDataName>>(CreateClientDocument, {
      alias: 'createClient',
      ...operationOptions
    });
};

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, baseOptions);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = ApolloReactCommon.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const CreateCustomQuoteDocument = gql`
    mutation createCustomQuote($data: CustomQuoteInput!) {
  createCustomQuote(data: $data) {
    id
    created_at
    updated_at
    name
    status
    nodes
    hours
  }
}
    `;
export type CreateCustomQuoteMutationFn = ApolloReactCommon.MutationFunction<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables>;
export type CreateCustomQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables>, 'mutation'>;

    export const CreateCustomQuoteComponent = (props: CreateCustomQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables> mutation={CreateCustomQuoteDocument} {...props} />
    );
    
export type CreateCustomQuoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables>
    } & TChildProps;
export function withCreateCustomQuote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCustomQuoteMutation,
  CreateCustomQuoteMutationVariables,
  CreateCustomQuoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables, CreateCustomQuoteProps<TChildProps, TDataName>>(CreateCustomQuoteDocument, {
      alias: 'createCustomQuote',
      ...operationOptions
    });
};

/**
 * __useCreateCustomQuoteMutation__
 *
 * To run a mutation, you first call `useCreateCustomQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomQuoteMutation, { data, loading, error }] = useCreateCustomQuoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables>(CreateCustomQuoteDocument, baseOptions);
      }
export type CreateCustomQuoteMutationHookResult = ReturnType<typeof useCreateCustomQuoteMutation>;
export type CreateCustomQuoteMutationResult = ApolloReactCommon.MutationResult<CreateCustomQuoteMutation>;
export type CreateCustomQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomQuoteMutation, CreateCustomQuoteMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation createDocument($data: DocumentInput) {
  createDocument(input: {data: $data}) {
    document {
      id
      created_at
      updated_at
      name
      link
      file {
        id
        url
      }
    }
  }
}
    `;
export type CreateDocumentMutationFn = ApolloReactCommon.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;
export type CreateDocumentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDocumentMutation, CreateDocumentMutationVariables>, 'mutation'>;

    export const CreateDocumentComponent = (props: CreateDocumentComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDocumentMutation, CreateDocumentMutationVariables> mutation={CreateDocumentDocument} {...props} />
    );
    
export type CreateDocumentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>
    } & TChildProps;
export function withCreateDocument<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDocumentMutation,
  CreateDocumentMutationVariables,
  CreateDocumentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDocumentMutation, CreateDocumentMutationVariables, CreateDocumentProps<TChildProps, TDataName>>(CreateDocumentDocument, {
      alias: 'createDocument',
      ...operationOptions
    });
};

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, baseOptions);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = ApolloReactCommon.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CreateFeatureTemplateDocument = gql`
    mutation createFeatureTemplate($data: FeatureTemplateInput!) {
  createFeatureTemplate(input: {data: $data}) {
    featureTemplate {
      id
    }
  }
}
    `;
export type CreateFeatureTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables>;
export type CreateFeatureTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables>, 'mutation'>;

    export const CreateFeatureTemplateComponent = (props: CreateFeatureTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables> mutation={CreateFeatureTemplateDocument} {...props} />
    );
    
export type CreateFeatureTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables>
    } & TChildProps;
export function withCreateFeatureTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateFeatureTemplateMutation,
  CreateFeatureTemplateMutationVariables,
  CreateFeatureTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables, CreateFeatureTemplateProps<TChildProps, TDataName>>(CreateFeatureTemplateDocument, {
      alias: 'createFeatureTemplate',
      ...operationOptions
    });
};

/**
 * __useCreateFeatureTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFeatureTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureTemplateMutation, { data, loading, error }] = useCreateFeatureTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFeatureTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables>(CreateFeatureTemplateDocument, baseOptions);
      }
export type CreateFeatureTemplateMutationHookResult = ReturnType<typeof useCreateFeatureTemplateMutation>;
export type CreateFeatureTemplateMutationResult = ApolloReactCommon.MutationResult<CreateFeatureTemplateMutation>;
export type CreateFeatureTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFeatureTemplateMutation, CreateFeatureTemplateMutationVariables>;
export const CreateLsaDocDocument = gql`
    mutation createLSADoc($data: LSAInput) {
  createLSADoc(data: $data) {
    url
  }
}
    `;
export type CreateLsaDocMutationFn = ApolloReactCommon.MutationFunction<CreateLsaDocMutation, CreateLsaDocMutationVariables>;
export type CreateLsaDocComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateLsaDocMutation, CreateLsaDocMutationVariables>, 'mutation'>;

    export const CreateLsaDocComponent = (props: CreateLsaDocComponentProps) => (
      <ApolloReactComponents.Mutation<CreateLsaDocMutation, CreateLsaDocMutationVariables> mutation={CreateLsaDocDocument} {...props} />
    );
    
export type CreateLsaDocProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateLsaDocMutation, CreateLsaDocMutationVariables>
    } & TChildProps;
export function withCreateLsaDoc<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateLsaDocMutation,
  CreateLsaDocMutationVariables,
  CreateLsaDocProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateLsaDocMutation, CreateLsaDocMutationVariables, CreateLsaDocProps<TChildProps, TDataName>>(CreateLsaDocDocument, {
      alias: 'createLsaDoc',
      ...operationOptions
    });
};

/**
 * __useCreateLsaDocMutation__
 *
 * To run a mutation, you first call `useCreateLsaDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLsaDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLsaDocMutation, { data, loading, error }] = useCreateLsaDocMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLsaDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLsaDocMutation, CreateLsaDocMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLsaDocMutation, CreateLsaDocMutationVariables>(CreateLsaDocDocument, baseOptions);
      }
export type CreateLsaDocMutationHookResult = ReturnType<typeof useCreateLsaDocMutation>;
export type CreateLsaDocMutationResult = ApolloReactCommon.MutationResult<CreateLsaDocMutation>;
export type CreateLsaDocMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLsaDocMutation, CreateLsaDocMutationVariables>;
export const CreatePmeDocDocument = gql`
    mutation createPMEDoc($id: ID!) {
  createPMEDoc(id: $id) {
    url
  }
}
    `;
export type CreatePmeDocMutationFn = ApolloReactCommon.MutationFunction<CreatePmeDocMutation, CreatePmeDocMutationVariables>;
export type CreatePmeDocComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreatePmeDocMutation, CreatePmeDocMutationVariables>, 'mutation'>;

    export const CreatePmeDocComponent = (props: CreatePmeDocComponentProps) => (
      <ApolloReactComponents.Mutation<CreatePmeDocMutation, CreatePmeDocMutationVariables> mutation={CreatePmeDocDocument} {...props} />
    );
    
export type CreatePmeDocProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreatePmeDocMutation, CreatePmeDocMutationVariables>
    } & TChildProps;
export function withCreatePmeDoc<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreatePmeDocMutation,
  CreatePmeDocMutationVariables,
  CreatePmeDocProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreatePmeDocMutation, CreatePmeDocMutationVariables, CreatePmeDocProps<TChildProps, TDataName>>(CreatePmeDocDocument, {
      alias: 'createPmeDoc',
      ...operationOptions
    });
};

/**
 * __useCreatePmeDocMutation__
 *
 * To run a mutation, you first call `useCreatePmeDocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePmeDocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPmeDocMutation, { data, loading, error }] = useCreatePmeDocMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreatePmeDocMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePmeDocMutation, CreatePmeDocMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePmeDocMutation, CreatePmeDocMutationVariables>(CreatePmeDocDocument, baseOptions);
      }
export type CreatePmeDocMutationHookResult = ReturnType<typeof useCreatePmeDocMutation>;
export type CreatePmeDocMutationResult = ApolloReactCommon.MutationResult<CreatePmeDocMutation>;
export type CreatePmeDocMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePmeDocMutation, CreatePmeDocMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($data: ProjectInput!) {
  createProject(input: {data: $data}) {
    project {
      id
      name
      description
    }
  }
}
    `;
export type CreateProjectMutationFn = ApolloReactCommon.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;
export type CreateProjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateProjectMutation, CreateProjectMutationVariables>, 'mutation'>;

    export const CreateProjectComponent = (props: CreateProjectComponentProps) => (
      <ApolloReactComponents.Mutation<CreateProjectMutation, CreateProjectMutationVariables> mutation={CreateProjectDocument} {...props} />
    );
    
export type CreateProjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>
    } & TChildProps;
export function withCreateProject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateProjectMutation,
  CreateProjectMutationVariables,
  CreateProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateProjectMutation, CreateProjectMutationVariables, CreateProjectProps<TChildProps, TDataName>>(CreateProjectDocument, {
      alias: 'createProject',
      ...operationOptions
    });
};

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, baseOptions);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = ApolloReactCommon.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateQuoteDocument = gql`
    mutation createQuote($data: QuoteInput!) {
  createQuote(input: {data: $data}) {
    quote {
      id
      created_at
      updated_at
      name
      status
    }
  }
}
    `;
export type CreateQuoteMutationFn = ApolloReactCommon.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;
export type CreateQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateQuoteMutation, CreateQuoteMutationVariables>, 'mutation'>;

    export const CreateQuoteComponent = (props: CreateQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<CreateQuoteMutation, CreateQuoteMutationVariables> mutation={CreateQuoteDocument} {...props} />
    );
    
export type CreateQuoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>
    } & TChildProps;
export function withCreateQuote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateQuoteMutation,
  CreateQuoteMutationVariables,
  CreateQuoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateQuoteMutation, CreateQuoteMutationVariables, CreateQuoteProps<TChildProps, TDataName>>(CreateQuoteDocument, {
      alias: 'createQuote',
      ...operationOptions
    });
};

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, baseOptions);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = ApolloReactCommon.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const CreateReportDocument = gql`
    mutation createReport($data: ReportInput!) {
  createReport(input: {data: $data}) {
    report {
      id
    }
  }
}
    `;
export type CreateReportMutationFn = ApolloReactCommon.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;
export type CreateReportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateReportMutation, CreateReportMutationVariables>, 'mutation'>;

    export const CreateReportComponent = (props: CreateReportComponentProps) => (
      <ApolloReactComponents.Mutation<CreateReportMutation, CreateReportMutationVariables> mutation={CreateReportDocument} {...props} />
    );
    
export type CreateReportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateReportMutation, CreateReportMutationVariables>
    } & TChildProps;
export function withCreateReport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateReportMutation,
  CreateReportMutationVariables,
  CreateReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateReportMutation, CreateReportMutationVariables, CreateReportProps<TChildProps, TDataName>>(CreateReportDocument, {
      alias: 'createReport',
      ...operationOptions
    });
};

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, baseOptions);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = ApolloReactCommon.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const CreateSolutionOverviewDocument = gql`
    mutation createSolutionOverview($id: ID!) {
  createSolutionOverview(id: $id) {
    url
  }
}
    `;
export type CreateSolutionOverviewMutationFn = ApolloReactCommon.MutationFunction<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables>;
export type CreateSolutionOverviewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables>, 'mutation'>;

    export const CreateSolutionOverviewComponent = (props: CreateSolutionOverviewComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables> mutation={CreateSolutionOverviewDocument} {...props} />
    );
    
export type CreateSolutionOverviewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables>
    } & TChildProps;
export function withCreateSolutionOverview<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSolutionOverviewMutation,
  CreateSolutionOverviewMutationVariables,
  CreateSolutionOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables, CreateSolutionOverviewProps<TChildProps, TDataName>>(CreateSolutionOverviewDocument, {
      alias: 'createSolutionOverview',
      ...operationOptions
    });
};

/**
 * __useCreateSolutionOverviewMutation__
 *
 * To run a mutation, you first call `useCreateSolutionOverviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSolutionOverviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSolutionOverviewMutation, { data, loading, error }] = useCreateSolutionOverviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateSolutionOverviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables>(CreateSolutionOverviewDocument, baseOptions);
      }
export type CreateSolutionOverviewMutationHookResult = ReturnType<typeof useCreateSolutionOverviewMutation>;
export type CreateSolutionOverviewMutationResult = ApolloReactCommon.MutationResult<CreateSolutionOverviewMutation>;
export type CreateSolutionOverviewMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSolutionOverviewMutation, CreateSolutionOverviewMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation createSubscription($data: SubscriptionInput!) {
  createSubscription(input: {data: $data}) {
    subscription {
      id
    }
  }
}
    `;
export type CreateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export type CreateSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>, 'mutation'>;

    export const CreateSubscriptionComponent = (props: CreateSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables> mutation={CreateSubscriptionDocument} {...props} />
    );
    
export type CreateSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables,
  CreateSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSubscriptionMutation, CreateSubscriptionMutationVariables, CreateSubscriptionProps<TChildProps, TDataName>>(CreateSubscriptionDocument, {
      alias: 'createSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, baseOptions);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation createTemplate($data: TemplateInput!) {
  createTemplate(input: {data: $data}) {
    template {
      id
      name
      flow
      hours
    }
  }
}
    `;
export type CreateTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;
export type CreateTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateTemplateMutation, CreateTemplateMutationVariables>, 'mutation'>;

    export const CreateTemplateComponent = (props: CreateTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<CreateTemplateMutation, CreateTemplateMutationVariables> mutation={CreateTemplateDocument} {...props} />
    );
    
export type CreateTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>
    } & TChildProps;
export function withCreateTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateTemplateMutation,
  CreateTemplateMutationVariables,
  CreateTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateTemplateMutation, CreateTemplateMutationVariables, CreateTemplateProps<TChildProps, TDataName>>(CreateTemplateDocument, {
      alias: 'createTemplate',
      ...operationOptions
    });
};

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, baseOptions);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = ApolloReactCommon.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: createUserInput) {
  createUser(input: $input) {
    user {
      id
      username
      email
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;
export type CreateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateUserMutation, CreateUserMutationVariables>, 'mutation'>;

    export const CreateUserComponent = (props: CreateUserComponentProps) => (
      <ApolloReactComponents.Mutation<CreateUserMutation, CreateUserMutationVariables> mutation={CreateUserDocument} {...props} />
    );
    
export type CreateUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>
    } & TChildProps;
export function withCreateUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateUserMutation,
  CreateUserMutationVariables,
  CreateUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateUserMutation, CreateUserMutationVariables, CreateUserProps<TChildProps, TDataName>>(CreateUserDocument, {
      alias: 'createUser',
      ...operationOptions
    });
};

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const EditCustomQuoteDocument = gql`
    mutation editCustomQuote($data: EditCustomQuoteInput!) {
  editCustomQuote(data: $data) {
    id
  }
}
    `;
export type EditCustomQuoteMutationFn = ApolloReactCommon.MutationFunction<EditCustomQuoteMutation, EditCustomQuoteMutationVariables>;
export type EditCustomQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EditCustomQuoteMutation, EditCustomQuoteMutationVariables>, 'mutation'>;

    export const EditCustomQuoteComponent = (props: EditCustomQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<EditCustomQuoteMutation, EditCustomQuoteMutationVariables> mutation={EditCustomQuoteDocument} {...props} />
    );
    
export type EditCustomQuoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EditCustomQuoteMutation, EditCustomQuoteMutationVariables>
    } & TChildProps;
export function withEditCustomQuote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditCustomQuoteMutation,
  EditCustomQuoteMutationVariables,
  EditCustomQuoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditCustomQuoteMutation, EditCustomQuoteMutationVariables, EditCustomQuoteProps<TChildProps, TDataName>>(EditCustomQuoteDocument, {
      alias: 'editCustomQuote',
      ...operationOptions
    });
};

/**
 * __useEditCustomQuoteMutation__
 *
 * To run a mutation, you first call `useEditCustomQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomQuoteMutation, { data, loading, error }] = useEditCustomQuoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditCustomQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditCustomQuoteMutation, EditCustomQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<EditCustomQuoteMutation, EditCustomQuoteMutationVariables>(EditCustomQuoteDocument, baseOptions);
      }
export type EditCustomQuoteMutationHookResult = ReturnType<typeof useEditCustomQuoteMutation>;
export type EditCustomQuoteMutationResult = ApolloReactCommon.MutationResult<EditCustomQuoteMutation>;
export type EditCustomQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<EditCustomQuoteMutation, EditCustomQuoteMutationVariables>;
export const InviteMemberDocument = gql`
    mutation inviteMember($data: InviteMemberInput) {
  inviteMember(data: $data) {
    id
  }
}
    `;
export type InviteMemberMutationFn = ApolloReactCommon.MutationFunction<InviteMemberMutation, InviteMemberMutationVariables>;
export type InviteMemberComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InviteMemberMutation, InviteMemberMutationVariables>, 'mutation'>;

    export const InviteMemberComponent = (props: InviteMemberComponentProps) => (
      <ApolloReactComponents.Mutation<InviteMemberMutation, InviteMemberMutationVariables> mutation={InviteMemberDocument} {...props} />
    );
    
export type InviteMemberProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InviteMemberMutation, InviteMemberMutationVariables>
    } & TChildProps;
export function withInviteMember<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InviteMemberMutation,
  InviteMemberMutationVariables,
  InviteMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InviteMemberMutation, InviteMemberMutationVariables, InviteMemberProps<TChildProps, TDataName>>(InviteMemberDocument, {
      alias: 'inviteMember',
      ...operationOptions
    });
};

/**
 * __useInviteMemberMutation__
 *
 * To run a mutation, you first call `useInviteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMemberMutation, { data, loading, error }] = useInviteMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteMemberMutation, InviteMemberMutationVariables>) {
        return ApolloReactHooks.useMutation<InviteMemberMutation, InviteMemberMutationVariables>(InviteMemberDocument, baseOptions);
      }
export type InviteMemberMutationHookResult = ReturnType<typeof useInviteMemberMutation>;
export type InviteMemberMutationResult = ApolloReactCommon.MutationResult<InviteMemberMutation>;
export type InviteMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<InviteMemberMutation, InviteMemberMutationVariables>;
export const QuoteApprovedStatusDocument = gql`
    mutation quoteApprovedStatus($id: ID!) {
  quoteApprovedStatus(id: $id) {
    status
  }
}
    `;
export type QuoteApprovedStatusMutationFn = ApolloReactCommon.MutationFunction<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables>;
export type QuoteApprovedStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables>, 'mutation'>;

    export const QuoteApprovedStatusComponent = (props: QuoteApprovedStatusComponentProps) => (
      <ApolloReactComponents.Mutation<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables> mutation={QuoteApprovedStatusDocument} {...props} />
    );
    
export type QuoteApprovedStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables>
    } & TChildProps;
export function withQuoteApprovedStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QuoteApprovedStatusMutation,
  QuoteApprovedStatusMutationVariables,
  QuoteApprovedStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables, QuoteApprovedStatusProps<TChildProps, TDataName>>(QuoteApprovedStatusDocument, {
      alias: 'quoteApprovedStatus',
      ...operationOptions
    });
};

/**
 * __useQuoteApprovedStatusMutation__
 *
 * To run a mutation, you first call `useQuoteApprovedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteApprovedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteApprovedStatusMutation, { data, loading, error }] = useQuoteApprovedStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteApprovedStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables>(QuoteApprovedStatusDocument, baseOptions);
      }
export type QuoteApprovedStatusMutationHookResult = ReturnType<typeof useQuoteApprovedStatusMutation>;
export type QuoteApprovedStatusMutationResult = ApolloReactCommon.MutationResult<QuoteApprovedStatusMutation>;
export type QuoteApprovedStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteApprovedStatusMutation, QuoteApprovedStatusMutationVariables>;
export const QuoteReviewStatusDocument = gql`
    mutation quoteReviewStatus($id: ID!) {
  quoteReviewStatus(id: $id) {
    status
  }
}
    `;
export type QuoteReviewStatusMutationFn = ApolloReactCommon.MutationFunction<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables>;
export type QuoteReviewStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables>, 'mutation'>;

    export const QuoteReviewStatusComponent = (props: QuoteReviewStatusComponentProps) => (
      <ApolloReactComponents.Mutation<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables> mutation={QuoteReviewStatusDocument} {...props} />
    );
    
export type QuoteReviewStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables>
    } & TChildProps;
export function withQuoteReviewStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QuoteReviewStatusMutation,
  QuoteReviewStatusMutationVariables,
  QuoteReviewStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables, QuoteReviewStatusProps<TChildProps, TDataName>>(QuoteReviewStatusDocument, {
      alias: 'quoteReviewStatus',
      ...operationOptions
    });
};

/**
 * __useQuoteReviewStatusMutation__
 *
 * To run a mutation, you first call `useQuoteReviewStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteReviewStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteReviewStatusMutation, { data, loading, error }] = useQuoteReviewStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteReviewStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables>(QuoteReviewStatusDocument, baseOptions);
      }
export type QuoteReviewStatusMutationHookResult = ReturnType<typeof useQuoteReviewStatusMutation>;
export type QuoteReviewStatusMutationResult = ApolloReactCommon.MutationResult<QuoteReviewStatusMutation>;
export type QuoteReviewStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteReviewStatusMutation, QuoteReviewStatusMutationVariables>;
export const SendReportEmailDocument = gql`
    mutation sendReportEmail($data: SendReportEmailInput) {
  sendReportEmail(data: $data) {
    sent
  }
}
    `;
export type SendReportEmailMutationFn = ApolloReactCommon.MutationFunction<SendReportEmailMutation, SendReportEmailMutationVariables>;
export type SendReportEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SendReportEmailMutation, SendReportEmailMutationVariables>, 'mutation'>;

    export const SendReportEmailComponent = (props: SendReportEmailComponentProps) => (
      <ApolloReactComponents.Mutation<SendReportEmailMutation, SendReportEmailMutationVariables> mutation={SendReportEmailDocument} {...props} />
    );
    
export type SendReportEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SendReportEmailMutation, SendReportEmailMutationVariables>
    } & TChildProps;
export function withSendReportEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendReportEmailMutation,
  SendReportEmailMutationVariables,
  SendReportEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SendReportEmailMutation, SendReportEmailMutationVariables, SendReportEmailProps<TChildProps, TDataName>>(SendReportEmailDocument, {
      alias: 'sendReportEmail',
      ...operationOptions
    });
};

/**
 * __useSendReportEmailMutation__
 *
 * To run a mutation, you first call `useSendReportEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReportEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReportEmailMutation, { data, loading, error }] = useSendReportEmailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendReportEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendReportEmailMutation, SendReportEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendReportEmailMutation, SendReportEmailMutationVariables>(SendReportEmailDocument, baseOptions);
      }
export type SendReportEmailMutationHookResult = ReturnType<typeof useSendReportEmailMutation>;
export type SendReportEmailMutationResult = ApolloReactCommon.MutationResult<SendReportEmailMutation>;
export type SendReportEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendReportEmailMutation, SendReportEmailMutationVariables>;
export const UpdateClientDocument = gql`
    mutation updateClient($id: ID!, $data: editClientInput!) {
  updateClient(input: {where: {id: $id}, data: $data}) {
    client {
      id
    }
  }
}
    `;
export type UpdateClientMutationFn = ApolloReactCommon.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;
export type UpdateClientComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateClientMutation, UpdateClientMutationVariables>, 'mutation'>;

    export const UpdateClientComponent = (props: UpdateClientComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateClientMutation, UpdateClientMutationVariables> mutation={UpdateClientDocument} {...props} />
    );
    
export type UpdateClientProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>
    } & TChildProps;
export function withUpdateClient<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateClientMutation,
  UpdateClientMutationVariables,
  UpdateClientProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateClientMutation, UpdateClientMutationVariables, UpdateClientProps<TChildProps, TDataName>>(UpdateClientDocument, {
      alias: 'updateClient',
      ...operationOptions
    });
};

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, baseOptions);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = ApolloReactCommon.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($id: ID!, $data: editProjectInput!) {
  updateProject(input: {where: {id: $id}, data: $data}) {
    project {
      id
      stakeholders {
        id
      }
    }
  }
}
    `;
export type UpdateProjectMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;
export type UpdateProjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProjectMutation, UpdateProjectMutationVariables>, 'mutation'>;

    export const UpdateProjectComponent = (props: UpdateProjectComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProjectMutation, UpdateProjectMutationVariables> mutation={UpdateProjectDocument} {...props} />
    );
    
export type UpdateProjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>
    } & TChildProps;
export function withUpdateProject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProjectMutation,
  UpdateProjectMutationVariables,
  UpdateProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProjectMutation, UpdateProjectMutationVariables, UpdateProjectProps<TChildProps, TDataName>>(UpdateProjectDocument, {
      alias: 'updateProject',
      ...operationOptions
    });
};

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, baseOptions);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = ApolloReactCommon.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($id: ID!, $data: editQuoteInput!) {
  updateQuote(input: {where: {id: $id}, data: $data}) {
    quote {
      id
      created_at
      updated_at
      submitted_at
      approved_at
      name
      nodes
      changes
      hours
      design
    }
  }
}
    `;
export type UpdateQuoteMutationFn = ApolloReactCommon.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export type UpdateQuoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>, 'mutation'>;

    export const UpdateQuoteComponent = (props: UpdateQuoteComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateQuoteMutation, UpdateQuoteMutationVariables> mutation={UpdateQuoteDocument} {...props} />
    );
    
export type UpdateQuoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>
    } & TChildProps;
export function withUpdateQuote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateQuoteMutation,
  UpdateQuoteMutationVariables,
  UpdateQuoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateQuoteMutation, UpdateQuoteMutationVariables, UpdateQuoteProps<TChildProps, TDataName>>(UpdateQuoteDocument, {
      alias: 'updateQuote',
      ...operationOptions
    });
};

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, baseOptions);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = ApolloReactCommon.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const UpdateReportDocument = gql`
    mutation updateReport($id: ID!, $data: editReportInput!) {
  updateReport(input: {where: {id: $id}, data: $data}) {
    report {
      id
    }
  }
}
    `;
export type UpdateReportMutationFn = ApolloReactCommon.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;
export type UpdateReportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateReportMutation, UpdateReportMutationVariables>, 'mutation'>;

    export const UpdateReportComponent = (props: UpdateReportComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateReportMutation, UpdateReportMutationVariables> mutation={UpdateReportDocument} {...props} />
    );
    
export type UpdateReportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>
    } & TChildProps;
export function withUpdateReport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateReportMutation,
  UpdateReportMutationVariables,
  UpdateReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateReportMutation, UpdateReportMutationVariables, UpdateReportProps<TChildProps, TDataName>>(UpdateReportDocument, {
      alias: 'updateReport',
      ...operationOptions
    });
};

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, baseOptions);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = ApolloReactCommon.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const ClientDocument = gql`
    query Client($id: ID!) {
  client(id: $id) {
    id
    created_at
    updated_at
    companyName
    website
    logo
    industry
    country
    size
    colour
    avatar {
      id
      url
    }
    projects {
      id
      name
    }
  }
}
    `;
export type ClientComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientQuery, ClientQueryVariables>, 'query'> & ({ variables: ClientQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ClientComponent = (props: ClientComponentProps) => (
      <ApolloReactComponents.Query<ClientQuery, ClientQueryVariables> query={ClientDocument} {...props} />
    );
    
export type ClientProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ClientQuery, ClientQueryVariables>
    } & TChildProps;
export function withClient<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientQuery,
  ClientQueryVariables,
  ClientProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ClientQuery, ClientQueryVariables, ClientProps<TChildProps, TDataName>>(ClientDocument, {
      alias: 'client',
      ...operationOptions
    });
};

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientQuery, ClientQueryVariables>) {
        return ApolloReactHooks.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, baseOptions);
      }
export function useClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, baseOptions);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientQueryResult = ApolloReactCommon.QueryResult<ClientQuery, ClientQueryVariables>;
export const ClientsDocument = gql`
    query Clients($sort: String, $limit: Int, $start: Int, $where: JSON) {
  clients(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    companyName
    website
    logo
    industry
    country
    size
    colour
    avatar {
      id
      url
    }
    projects {
      id
      name
    }
  }
  totalClients
}
    `;
export type ClientsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientsQuery, ClientsQueryVariables>, 'query'>;

    export const ClientsComponent = (props: ClientsComponentProps) => (
      <ApolloReactComponents.Query<ClientsQuery, ClientsQueryVariables> query={ClientsDocument} {...props} />
    );
    
export type ClientsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ClientsQuery, ClientsQueryVariables>
    } & TChildProps;
export function withClients<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientsQuery,
  ClientsQueryVariables,
  ClientsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ClientsQuery, ClientsQueryVariables, ClientsProps<TChildProps, TDataName>>(ClientsDocument, {
      alias: 'clients',
      ...operationOptions
    });
};

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
        return ApolloReactHooks.useQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, baseOptions);
      }
export function useClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, baseOptions);
        }
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsQueryResult = ApolloReactCommon.QueryResult<ClientsQuery, ClientsQueryVariables>;
export const GetDashboardDocument = gql`
    query getDashboard {
  getDashboard {
    reviewQuotes {
      id
      name
      hours
      created_at
      updated_at
    }
    recentApprovedQuotes {
      id
      name
      hours
      created_at
      updated_at
    }
    createdQuotes {
      id
      created_at
    }
    submittedQuotes {
      id
      submitted_at
    }
    approvedQuotes {
      id
      approved_at
    }
  }
}
    `;
export type GetDashboardComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDashboardQuery, GetDashboardQueryVariables>, 'query'>;

    export const GetDashboardComponent = (props: GetDashboardComponentProps) => (
      <ApolloReactComponents.Query<GetDashboardQuery, GetDashboardQueryVariables> query={GetDashboardDocument} {...props} />
    );
    
export type GetDashboardProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDashboardQuery, GetDashboardQueryVariables>
    } & TChildProps;
export function withGetDashboard<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDashboardQuery,
  GetDashboardQueryVariables,
  GetDashboardProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDashboardQuery, GetDashboardQueryVariables, GetDashboardProps<TChildProps, TDataName>>(GetDashboardDocument, {
      alias: 'getDashboard',
      ...operationOptions
    });
};

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, baseOptions);
      }
export function useGetDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, baseOptions);
        }
export type GetDashboardQueryHookResult = ReturnType<typeof useGetDashboardQuery>;
export type GetDashboardLazyQueryHookResult = ReturnType<typeof useGetDashboardLazyQuery>;
export type GetDashboardQueryResult = ApolloReactCommon.QueryResult<GetDashboardQuery, GetDashboardQueryVariables>;
export const DocumentsDocument = gql`
    query Documents($sort: String, $limit: Int, $start: Int, $where: JSON) {
  documents(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    name
    link
    file {
      id
      url
    }
  }
}
    `;
export type DocumentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DocumentsQuery, DocumentsQueryVariables>, 'query'>;

    export const DocumentsComponent = (props: DocumentsComponentProps) => (
      <ApolloReactComponents.Query<DocumentsQuery, DocumentsQueryVariables> query={DocumentsDocument} {...props} />
    );
    
export type DocumentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DocumentsQuery, DocumentsQueryVariables>
    } & TChildProps;
export function withDocuments<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DocumentsQuery,
  DocumentsQueryVariables,
  DocumentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DocumentsQuery, DocumentsQueryVariables, DocumentsProps<TChildProps, TDataName>>(DocumentsDocument, {
      alias: 'documents',
      ...operationOptions
    });
};

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        return ApolloReactHooks.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, baseOptions);
      }
export function useDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, baseOptions);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = ApolloReactCommon.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const FeatureTemplateDocument = gql`
    query FeatureTemplate($id: ID!) {
  featureTemplate(id: $id) {
    id
    thumbnail {
      id
      url
    }
    desktop {
      id
      url
    }
    mobile {
      id
      url
    }
    integration
    custom
  }
}
    `;
export type FeatureTemplateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeatureTemplateQuery, FeatureTemplateQueryVariables>, 'query'> & ({ variables: FeatureTemplateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeatureTemplateComponent = (props: FeatureTemplateComponentProps) => (
      <ApolloReactComponents.Query<FeatureTemplateQuery, FeatureTemplateQueryVariables> query={FeatureTemplateDocument} {...props} />
    );
    
export type FeatureTemplateProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FeatureTemplateQuery, FeatureTemplateQueryVariables>
    } & TChildProps;
export function withFeatureTemplate<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FeatureTemplateQuery,
  FeatureTemplateQueryVariables,
  FeatureTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FeatureTemplateQuery, FeatureTemplateQueryVariables, FeatureTemplateProps<TChildProps, TDataName>>(FeatureTemplateDocument, {
      alias: 'featureTemplate',
      ...operationOptions
    });
};

/**
 * __useFeatureTemplateQuery__
 *
 * To run a query within a React component, call `useFeatureTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureTemplateQuery, FeatureTemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<FeatureTemplateQuery, FeatureTemplateQueryVariables>(FeatureTemplateDocument, baseOptions);
      }
export function useFeatureTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureTemplateQuery, FeatureTemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeatureTemplateQuery, FeatureTemplateQueryVariables>(FeatureTemplateDocument, baseOptions);
        }
export type FeatureTemplateQueryHookResult = ReturnType<typeof useFeatureTemplateQuery>;
export type FeatureTemplateLazyQueryHookResult = ReturnType<typeof useFeatureTemplateLazyQuery>;
export type FeatureTemplateQueryResult = ApolloReactCommon.QueryResult<FeatureTemplateQuery, FeatureTemplateQueryVariables>;
export const FeatureTemplatesDocument = gql`
    query FeatureTemplates($sort: String, $limit: Int, $start: Int, $where: JSON) {
  featureTemplates(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    name
    description
    hours
    integration
    custom
  }
}
    `;
export type FeatureTemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>, 'query'>;

    export const FeatureTemplatesComponent = (props: FeatureTemplatesComponentProps) => (
      <ApolloReactComponents.Query<FeatureTemplatesQuery, FeatureTemplatesQueryVariables> query={FeatureTemplatesDocument} {...props} />
    );
    
export type FeatureTemplatesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>
    } & TChildProps;
export function withFeatureTemplates<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FeatureTemplatesQuery,
  FeatureTemplatesQueryVariables,
  FeatureTemplatesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FeatureTemplatesQuery, FeatureTemplatesQueryVariables, FeatureTemplatesProps<TChildProps, TDataName>>(FeatureTemplatesDocument, {
      alias: 'featureTemplates',
      ...operationOptions
    });
};

/**
 * __useFeatureTemplatesQuery__
 *
 * To run a query within a React component, call `useFeatureTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureTemplatesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFeatureTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>(FeatureTemplatesDocument, baseOptions);
      }
export function useFeatureTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>(FeatureTemplatesDocument, baseOptions);
        }
export type FeatureTemplatesQueryHookResult = ReturnType<typeof useFeatureTemplatesQuery>;
export type FeatureTemplatesLazyQueryHookResult = ReturnType<typeof useFeatureTemplatesLazyQuery>;
export type FeatureTemplatesQueryResult = ApolloReactCommon.QueryResult<FeatureTemplatesQuery, FeatureTemplatesQueryVariables>;
export const ProjectDocument = gql`
    query Project($id: ID!) {
  project(id: $id) {
    id
    created_at
    updated_at
    name
    description
    problem
    solution
    market
    industry
    users
    need
    geography
    frequency
    status
    actual_duration
    logo {
      id
      url
    }
    quotes {
      id
      created_at
      updated_at
      name
      hours
      status
    }
    client {
      id
      companyName
      logo
    }
    stakeholders {
      id
      username
      email
      phoneNumber
      role {
        name
      }
    }
  }
}
    `;
export type ProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectQuery, ProjectQueryVariables>, 'query'> & ({ variables: ProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectComponent = (props: ProjectComponentProps) => (
      <ApolloReactComponents.Query<ProjectQuery, ProjectQueryVariables> query={ProjectDocument} {...props} />
    );
    
export type ProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectQuery, ProjectQueryVariables>
    } & TChildProps;
export function withProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectQuery,
  ProjectQueryVariables,
  ProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectQuery, ProjectQueryVariables, ProjectProps<TChildProps, TDataName>>(ProjectDocument, {
      alias: 'project',
      ...operationOptions
    });
};

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
        return ApolloReactHooks.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, baseOptions);
      }
export function useProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, baseOptions);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectQueryResult = ApolloReactCommon.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const ProjectsDocument = gql`
    query Projects($sort: String, $limit: Int, $start: Int, $where: JSON) {
  projects(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    name
    description
    status
    rep {
      id
      fullName
      username
      role {
        name
      }
    }
    client {
      id
      companyName
      logo
    }
    stakeholders {
      id
      username
      email
    }
  }
  totalProjects
}
    `;
export type ProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectsQuery, ProjectsQueryVariables>, 'query'>;

    export const ProjectsComponent = (props: ProjectsComponentProps) => (
      <ApolloReactComponents.Query<ProjectsQuery, ProjectsQueryVariables> query={ProjectsDocument} {...props} />
    );
    
export type ProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectsQuery, ProjectsQueryVariables>
    } & TChildProps;
export function withProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectsQuery,
  ProjectsQueryVariables,
  ProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectsQuery, ProjectsQueryVariables, ProjectsProps<TChildProps, TDataName>>(ProjectsDocument, {
      alias: 'projects',
      ...operationOptions
    });
};

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        return ApolloReactHooks.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, baseOptions);
      }
export function useProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, baseOptions);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = ApolloReactCommon.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const QuoteDocument = gql`
    query Quote($id: ID!) {
  quote(id: $id) {
    id
    created_at
    updated_at
    approved_at
    submitted_at
    name
    status
    nodes
    hours
    design
    changes
    project {
      id
      name
      partner
      client {
        companyName
      }
    }
  }
}
    `;
export type QuoteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QuoteQuery, QuoteQueryVariables>, 'query'> & ({ variables: QuoteQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QuoteComponent = (props: QuoteComponentProps) => (
      <ApolloReactComponents.Query<QuoteQuery, QuoteQueryVariables> query={QuoteDocument} {...props} />
    );
    
export type QuoteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<QuoteQuery, QuoteQueryVariables>
    } & TChildProps;
export function withQuote<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QuoteQuery,
  QuoteQueryVariables,
  QuoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, QuoteQuery, QuoteQueryVariables, QuoteProps<TChildProps, TDataName>>(QuoteDocument, {
      alias: 'quote',
      ...operationOptions
    });
};

/**
 * __useQuoteQuery__
 *
 * To run a query within a React component, call `useQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
        return ApolloReactHooks.useQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, baseOptions);
      }
export function useQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, baseOptions);
        }
export type QuoteQueryHookResult = ReturnType<typeof useQuoteQuery>;
export type QuoteLazyQueryHookResult = ReturnType<typeof useQuoteLazyQuery>;
export type QuoteQueryResult = ApolloReactCommon.QueryResult<QuoteQuery, QuoteQueryVariables>;
export const QuotesDocument = gql`
    query Quotes($sort: String, $limit: Int, $start: Int, $where: JSON) {
  quotes(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    approved_at
    submitted_at
    name
    status
    hours
    design
  }
  totalQuotes
}
    `;
export type QuotesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QuotesQuery, QuotesQueryVariables>, 'query'>;

    export const QuotesComponent = (props: QuotesComponentProps) => (
      <ApolloReactComponents.Query<QuotesQuery, QuotesQueryVariables> query={QuotesDocument} {...props} />
    );
    
export type QuotesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<QuotesQuery, QuotesQueryVariables>
    } & TChildProps;
export function withQuotes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QuotesQuery,
  QuotesQueryVariables,
  QuotesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, QuotesQuery, QuotesQueryVariables, QuotesProps<TChildProps, TDataName>>(QuotesDocument, {
      alias: 'quotes',
      ...operationOptions
    });
};

/**
 * __useQuotesQuery__
 *
 * To run a query within a React component, call `useQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useQuotesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QuotesQuery, QuotesQueryVariables>) {
        return ApolloReactHooks.useQuery<QuotesQuery, QuotesQueryVariables>(QuotesDocument, baseOptions);
      }
export function useQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuotesQuery, QuotesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<QuotesQuery, QuotesQueryVariables>(QuotesDocument, baseOptions);
        }
export type QuotesQueryHookResult = ReturnType<typeof useQuotesQuery>;
export type QuotesLazyQueryHookResult = ReturnType<typeof useQuotesLazyQuery>;
export type QuotesQueryResult = ApolloReactCommon.QueryResult<QuotesQuery, QuotesQueryVariables>;
export const ReportsDocument = gql`
    query Reports($sort: String, $limit: Int, $start: Int, $where: JSON) {
  reports(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    date
    subscription {
      id
      name
    }
    invoice {
      id
      url
    }
    nps {
      id
      url
    }
    progress {
      id
      url
    }
  }
}
    `;
export type ReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReportsQuery, ReportsQueryVariables>, 'query'>;

    export const ReportsComponent = (props: ReportsComponentProps) => (
      <ApolloReactComponents.Query<ReportsQuery, ReportsQueryVariables> query={ReportsDocument} {...props} />
    );
    
export type ReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ReportsQuery, ReportsQueryVariables>
    } & TChildProps;
export function withReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReportsQuery,
  ReportsQueryVariables,
  ReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ReportsQuery, ReportsQueryVariables, ReportsProps<TChildProps, TDataName>>(ReportsDocument, {
      alias: 'reports',
      ...operationOptions
    });
};

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        return ApolloReactHooks.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, baseOptions);
      }
export function useReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, baseOptions);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = ApolloReactCommon.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const SubscriptionDocument = gql`
    query Subscription($id: ID!) {
  subscription(id: $id) {
    id
    created_at
    updated_at
    name
    hours
    start
    end
    status
    reports(sort: "date:desc") {
      id
      created_at
      updated_at
      date
      invoice {
        id
        url
      }
      nps {
        id
        url
      }
      progress {
        id
        url
      }
    }
  }
}
    `;
export type SubscriptionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SubscriptionQuery, SubscriptionQueryVariables>, 'query'> & ({ variables: SubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubscriptionComponent = (props: SubscriptionComponentProps) => (
      <ApolloReactComponents.Query<SubscriptionQuery, SubscriptionQueryVariables> query={SubscriptionDocument} {...props} />
    );
    
export type SubscriptionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscriptionQuery, SubscriptionQueryVariables>
    } & TChildProps;
export function withSubscription<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscriptionQuery,
  SubscriptionQueryVariables,
  SubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SubscriptionQuery, SubscriptionQueryVariables, SubscriptionProps<TChildProps, TDataName>>(SubscriptionDocument, {
      alias: 'subscription',
      ...operationOptions
    });
};

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, baseOptions);
      }
export function useSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, baseOptions);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionQueryResult = ApolloReactCommon.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions($sort: String, $limit: Int, $start: Int, $where: JSON) {
  subscriptions(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    name
    hours
    start
    end
    status
  }
}
    `;
export type SubscriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SubscriptionsQuery, SubscriptionsQueryVariables>, 'query'>;

    export const SubscriptionsComponent = (props: SubscriptionsComponentProps) => (
      <ApolloReactComponents.Query<SubscriptionsQuery, SubscriptionsQueryVariables> query={SubscriptionsDocument} {...props} />
    );
    
export type SubscriptionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscriptionsQuery, SubscriptionsQueryVariables>
    } & TChildProps;
export function withSubscriptions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscriptionsQuery,
  SubscriptionsQueryVariables,
  SubscriptionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SubscriptionsQuery, SubscriptionsQueryVariables, SubscriptionsProps<TChildProps, TDataName>>(SubscriptionsDocument, {
      alias: 'subscriptions',
      ...operationOptions
    });
};

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, baseOptions);
      }
export function useSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, baseOptions);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsQueryResult = ApolloReactCommon.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const TemplateDocument = gql`
    query Template($id: ID!) {
  template(id: $id) {
    id
    name
    flow
    hours
  }
}
    `;
export type TemplateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TemplateQuery, TemplateQueryVariables>, 'query'> & ({ variables: TemplateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TemplateComponent = (props: TemplateComponentProps) => (
      <ApolloReactComponents.Query<TemplateQuery, TemplateQueryVariables> query={TemplateDocument} {...props} />
    );
    
export type TemplateProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TemplateQuery, TemplateQueryVariables>
    } & TChildProps;
export function withTemplate<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TemplateQuery,
  TemplateQueryVariables,
  TemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TemplateQuery, TemplateQueryVariables, TemplateProps<TChildProps, TDataName>>(TemplateDocument, {
      alias: 'template',
      ...operationOptions
    });
};

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
        return ApolloReactHooks.useQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, baseOptions);
      }
export function useTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, baseOptions);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = ApolloReactCommon.QueryResult<TemplateQuery, TemplateQueryVariables>;
export const TemplatesDocument = gql`
    query Templates($sort: String, $limit: Int, $start: Int, $where: JSON) {
  templates(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    name
    flow
    hours
  }
}
    `;
export type TemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TemplatesQuery, TemplatesQueryVariables>, 'query'>;

    export const TemplatesComponent = (props: TemplatesComponentProps) => (
      <ApolloReactComponents.Query<TemplatesQuery, TemplatesQueryVariables> query={TemplatesDocument} {...props} />
    );
    
export type TemplatesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TemplatesQuery, TemplatesQueryVariables>
    } & TChildProps;
export function withTemplates<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TemplatesQuery,
  TemplatesQueryVariables,
  TemplatesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TemplatesQuery, TemplatesQueryVariables, TemplatesProps<TChildProps, TDataName>>(TemplatesDocument, {
      alias: 'templates',
      ...operationOptions
    });
};

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
        return ApolloReactHooks.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, baseOptions);
      }
export function useTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, baseOptions);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesQueryResult = ApolloReactCommon.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const TermsDocument = gql`
    query Terms($sort: String, $limit: Int, $start: Int, $where: JSON) {
  terms(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    name
    document {
      id
      url
    }
  }
}
    `;
export type TermsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TermsQuery, TermsQueryVariables>, 'query'>;

    export const TermsComponent = (props: TermsComponentProps) => (
      <ApolloReactComponents.Query<TermsQuery, TermsQueryVariables> query={TermsDocument} {...props} />
    );
    
export type TermsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TermsQuery, TermsQueryVariables>
    } & TChildProps;
export function withTerms<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TermsQuery,
  TermsQueryVariables,
  TermsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TermsQuery, TermsQueryVariables, TermsProps<TChildProps, TDataName>>(TermsDocument, {
      alias: 'terms',
      ...operationOptions
    });
};

/**
 * __useTermsQuery__
 *
 * To run a query within a React component, call `useTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTermsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TermsQuery, TermsQueryVariables>) {
        return ApolloReactHooks.useQuery<TermsQuery, TermsQueryVariables>(TermsDocument, baseOptions);
      }
export function useTermsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TermsQuery, TermsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TermsQuery, TermsQueryVariables>(TermsDocument, baseOptions);
        }
export type TermsQueryHookResult = ReturnType<typeof useTermsQuery>;
export type TermsLazyQueryHookResult = ReturnType<typeof useTermsLazyQuery>;
export type TermsQueryResult = ApolloReactCommon.QueryResult<TermsQuery, TermsQueryVariables>;
export const UsersDocument = gql`
    query Users($sort: String, $limit: Int, $start: Int, $where: JSON) {
  users(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    created_at
    updated_at
    username
    email
    provider
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
    phoneNumber
    profilePicture {
      id
      url
    }
    fullName
  }
}
    `;
export type UsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UsersQuery, UsersQueryVariables>, 'query'>;

    export const UsersComponent = (props: UsersComponentProps) => (
      <ApolloReactComponents.Query<UsersQuery, UsersQueryVariables> query={UsersDocument} {...props} />
    );
    
export type UsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UsersQuery, UsersQueryVariables>
    } & TChildProps;
export function withUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UsersQuery,
  UsersQueryVariables,
  UsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UsersQuery, UsersQueryVariables, UsersProps<TChildProps, TDataName>>(UsersDocument, {
      alias: 'users',
      ...operationOptions
    });
};

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = ApolloReactCommon.QueryResult<UsersQuery, UsersQueryVariables>;